/**
 * This is an AUTOGENERATED FILE generated by shared/enum_generator.py.
 * DO NOT modify this file manually.
 * To update this file, modify shared/enums.json5 and run shared/enum_generator.py.
 */

export enum CollectionReportChangeType {
  ENFORCEMENT_REQUEST_STATUS = "enforcement_request_status",
  IMPORTANCE_SCORE = "importance_score",
  MAX_SIMILARITY_SCORE = "max_similarity_score",
  SPOOF_STATUS = "spoof_status",
  REPORT_STATUS = "report_status",
  SCORE = "score",
  NOTES = "notes",
  INTERNAL_NOTES = "internal_notes",
  REPORT_CREATE = "report_create",
  ALERT_CREATE = "alert_create",
  REPORT_ADD_MATCH = "report_add_match",
  SNAPSHOT_CREATE = "snapshot_create",
  ENFORCEMENT_EMAIL_STATUS = "enforcement_email_status",
  MATCH_STATUS = "match_status",
  BRAND = "brand",
  PLATFORM_SUBTYPE = "platform_subtype",
  TAG_ACTION = "tag_action",
  TAG_ADD = "tag_add",
  TAG_REMOVE = "tag_remove",
  FILE_ACTION = "file_action",
  ADD_LINK = "add_link",
  REMOVE_LINK = "remove_link",
  SEVERITY = "severity",
  INTERNAL_ASSIGNEE_CHANGE = "internal_alert_assignee",
  EXTERNAL_ASSIGNEE_CHANGE = "external_alert_assignee",
}

export const CollectionReportChangeTypeLabels: { [key in CollectionReportChangeType]?: string } = {
  [CollectionReportChangeType.ENFORCEMENT_REQUEST_STATUS]: "enforcement_status",
  [CollectionReportChangeType.IMPORTANCE_SCORE]: "importance_score",
  [CollectionReportChangeType.MAX_SIMILARITY_SCORE]: "similarity_score",
  [CollectionReportChangeType.SPOOF_STATUS]: "entity_state",
  [CollectionReportChangeType.REPORT_STATUS]: "queue_state",
  [CollectionReportChangeType.SCORE]: "suspicion_score",
  [CollectionReportChangeType.NOTES]: "notes",
  [CollectionReportChangeType.INTERNAL_NOTES]: "internal_notes",
  [CollectionReportChangeType.REPORT_CREATE]: "report_created",
  [CollectionReportChangeType.ALERT_CREATE]: "alert_create",
  [CollectionReportChangeType.REPORT_ADD_MATCH]: "url_added",
  [CollectionReportChangeType.SNAPSHOT_CREATE]: "snapshot_create",
  [CollectionReportChangeType.ENFORCEMENT_EMAIL_STATUS]: "enforcement_email_status",
  [CollectionReportChangeType.MATCH_STATUS]: "url_classification",
  [CollectionReportChangeType.BRAND]: "brand",
  [CollectionReportChangeType.PLATFORM_SUBTYPE]: "platform",
  [CollectionReportChangeType.TAG_ACTION]: "tag_action",
  [CollectionReportChangeType.TAG_ADD]: "tag_add",
  [CollectionReportChangeType.TAG_REMOVE]: "tag_remove",
  [CollectionReportChangeType.FILE_ACTION]: "file_action",
  [CollectionReportChangeType.ADD_LINK]: "add_link",
  [CollectionReportChangeType.REMOVE_LINK]: "remove_link",
  [CollectionReportChangeType.SEVERITY]: "severity",
  [CollectionReportChangeType.INTERNAL_ASSIGNEE_CHANGE]: "internal_alert_assignee",
  [CollectionReportChangeType.EXTERNAL_ASSIGNEE_CHANGE]: "external_alert_assignee",
};

export enum PlatformName {
  APIFY_APP_STORE = "apify_app_store",
  DOMAIN = "domain",
  SOCIAL_MEDIA = "social_media",
  TWITTER = "twitter",
  FACEBOOK = "facebook",
  FACEBOOK_MARKETPLACE = "facebook_marketplace",
  FACEBOOK_WEB = "facebook_web",
  FACEBOOK_ADS = "facebook_ads",
  CLOUDFLARE = "cloudflare",
  VERCEL = "vercel",
  INSTAGRAM = "instagram",
  YOUTUBE = "youtube",
  TIKTOK = "tiktok",
  TELCO = "telco",
  REDDIT = "reddit",
  GITHUB = "github",
  MEDIUM = "medium",
  DISCORD = "discord",
  TWITCH = "twitch",
  TELEGRAM = "telegram",
  BITLY = "bitly",
  LINKEDIN = "linkedin",
  LINKTREE = "linktree",
  PINTEREST = "pinterest",
  SNAPCHAT = "snapchat",
  WHATSAPP = "whatsapp",
  WEIBO = "weibo",
  TUMBLR = "tumblr",
  QUORA = "quora",
  SOUNDCLOUD = "soundcloud",
  FLICKR = "flickr",
  DRIBBBLE = "dribbble",
  DEVIANTART = "deviantart",
  FOURSQUARE = "foursquare",
  IMGUR = "imgur",
  MEETUP = "meetup",
  PATREON = "patreon",
  SLIDESHARE = "slideshare",
  SLIDES = "slides",
  SPOTIFY = "spotify",
  VIMEO = "vimeo",
  CHROME_WEB_STORE = "chrome_web_store",
  GOOGLE_PLAY_STORE = "google_play_store",
  APPLE_APP_STORE = "apple_app_store",
  GETJAR_APP_STORE = "getjar_app_store",
  NINEAPPS_APP_STORE = "9apps_app_store",
  NINENINEIMAGES_APP_STORE = "99images_app_store",
  AMAZON_APP_STORE = "amazon_app_store",
  APKAIO_APP_STORE = "apkaio_app_store",
  APKBOG_APP_STORE = "apkbog_app_store",
  APKCOMBO_APP_STORE = "apkcombo_app_store",
  APKDOG_APP_STORE = "apkdog_app_store",
  APKLUST_APP_STORE = "apklust_app_store",
  APK4K_APP_STORE = "apk4k_app_store",
  APKFREE_APP_STORE = "apkfree_app_store",
  APKFUN_APP_STORE = "apkfun_app_store",
  APKFAB_APP_STORE = "apkfab_app_store",
  APKGK_APP_STORE = "apkgk_app_store",
  APKGOLD_APP_STORE = "apkgold_app_store",
  APKHOUSE_APP_STORE = "apkhouse_app_store",
  APKMODY_APP_STORE = "apkmody_app_store",
  APKMONK_APP_STORE = "apkmonk_app_store",
  APKRESULT_APP_STORE = "apkresult_app_store",
  APKSOS_APP_STORE = "apksos_app_store",
  APKSUPPORT_APP_STORE = "apksupport_app_store",
  APKPURE_APP_STORE = "apkpure_app_store",
  APKMIRROR_APP_STORE = "apkmirror_app_store",
  APKTOY_APP_STORE = "apktoy_app_store",
  APPBRAIN_APP_STORE = "appbrain_app_store",
  APPSONWINDOWS_APP_STORE = "appsonwindows_app_store",
  APTOIDE_APP_STORE = "aptoide_app_store",
  CCM_APP_STORE = "ccm_app_store",
  CNET_APP_STORE = "cnet_app_store",
  FILEHIPPO_APP_STORE = "filehippo_app_store",
  OPERA_MOBILE_STORE = "opera_mobile_store",
  CAFEBAZAAR_APP_STORE = "cafebazaar_app_store",
  COMPSMAG_APP_STORE = "compsmag_app_store",
  FILEHORSE_APP_STORE = "filehorse_app_store",
  GAMELOOP_APP_STORE = "gameloop_app_store",
  HAPPYMOD_APP_STORE = "happymod_app_store",
  IODROID_APP_STORE = "iodroid_app_store",
  MALAVIDA_APP_STORE = "malavida_app_store",
  MEMUPLAY_APP_STORE = "memuplay_app_store",
  PCMAC_APP_STORE = "pcmac_app_store",
  PLAYMODS_APP_STORE = "playmods_app_store",
  MICROSOFT_APP_STORE = "microsoft_app_store",
  SOFTFORPC_APP_STORE = "softforpc_app_store",
  SOFTONIC_APP_STORE = "softonic_app_store",
  SOFTSTON_APP_STORE = "softston_app_store",
  STEPRIMO_APP_STORE = "steprimo_app_store",
  UPTODOWN_APP_STORE = "uptodown_app_store",
  GALAXY_APP_STORE = "galaxy_app_store",
  BITQUERY = "bitquery",
  COINALPHA = "coinalpha",
  COINBASE = "coinbase",
  COINBRAIN = "coinbrain",
  COINCARP = "coincarp",
  COINPARE = "coinpare",
  COINPAPRIKA = "coinpaprika",
  COINRANKING = "coinranking",
  CRYPTO = "crypto.com",
  CRYPTORANK = "cryptorank",
  BINANCE = "binance",
  KUCOIN = "kucoin",
  COINMARKETCAP = "coinmarketcap",
  COINGECKO = "coingecko",
  GATE = "gate",
  GECKOTERMINAL = "geckoterminal",
  LOOKSRARE = "looksrare",
  MESSARI = "messari",
  MINTABLE = "mintable",
  NIFTYGATEWAY = "niftygateway",
  OKX = "okx",
  OPENSEA = "opensea",
  POOCOIN = "poocoin",
  RARIBLE = "rarible",
  SUIEXPLORER = "suiexplorer",
  THEBITTIMES = "thebittimes",
  TOKENINSIGHT = "tokeninsight",
  TOFUNFT = "tofunft",
  TROPEE = "tropee",
  UNISWAP = "uniswap",
  WITHKOJI = "withkoji",
  X2Y2 = "x2y2",
  XT = "xt",
  ZEALY = "zealy",
  GOOGLE_ADS = "google_ads",
  BING_ADS = "bing_ads",
  YAHOO_ADS = "yahoo_ads",
  GMAIL = "gmail",
  YAHOO_MAIL = "yahoo_mail",
  BLOGSPOT = "blogspot",
  GOOGLE_DOCS = "google_docs",
  WIXSITE = "wixsite",
  WORDPRESS = "wordpress",
  MAGICEDEN = "magiceden",
  DEBANK = "debank",
  SUBSTACK = "substack",
  CARRD = "carrd",
  ONLYFANS = "onlyfans",
  BEACONS = "beacons",
  LAUNCHMYNFT = "launchmynft",
  TOPAZ = "topaz",
  ARTSTATION = "artstation",
  TINYURL = "tinyurl",
  LINK3 = "link3",
  RAC1 = "rac1",
  PROOF = "proof",
  MUCKRACK = "muckrack",
  ALLMYLINKS = "allmylinks",
  CURIOUSCAT = "curiouscat",
  PAYPAL = "paypal",
  NETLIFY = "netlify",
  KO_FI = "ko-fi",
  ASK_FM = "ask.fm",
  WEEBLY = "weebly",
  STASHH = "stashh",
  TAPLINK = "taplink",
  FANDOM = "fandom",
  WEB_APP = "web.app",
  LIVESMINTNFT = "livesmintnft",
  BIO_LINK = "bio.link",
  ABOUT_ME = "about.me",
  FANSLY = "fansly",
  GOOGLE_DRIVE = "google_drive",
  AMAZON = "amazon",
  BORED_APE_WEAR = "bored_ape_wear",
  CRYPTO_GOODIES = "crypto_goodies",
  EBAY = "ebay",
  ETSY = "etsy",
  REDBUBBLE = "redbubble",
  SHOPIFY = "shopify",
  TEE7DAYS = "tee7days",
  WISH = "wish",
  ZATEENO = "zateeno",
  EMAIL = "email",
  ROBLOX = "roblox",
  DARKWEB = "darkweb",
  CRED_LEAKS = "cred_leaks",
  CREDIT_CARD_LEAKS = "credit_card_leaks",
  API_LEAKS = "api_leaks",
  THREADS = "threads",
  MISC_ECOMMERCE = "misc_ecommerce",
  SHELLIX = "shellix",
  GOOGLE_SITES = "google_sites",
  CRUNCHBASE = "crunchbase",
  WALMART = "walmart",
  GOOGLE_SEARCH = "google_search",
  APIFY_APP_STORES = "apify_app_stores",
  SUSPICIOUS_EMAILS = "suspicious_emails",
}

export enum ReportStatus {
  NEEDS_REVIEW = "needs_review",
  NEEDS_ACTION = "needs_action",
  NO_ACTION = "approved_derivative",
  REPORTED = "reported",
  RESOLVED = "resolved",
  ARCHIVED = "archived",
  INTERNAL_REVIEW = "internal_review",
  INTERNAL_IGNORED = "internal_ignored",
  INTERNAL_ARCHIVED = "internal_archived",
  TESTING = "testing",
}

export const ReportStatusLabels: { [key in ReportStatus]?: string } = {
  [ReportStatus.NEEDS_REVIEW]: "doppel_review",
  [ReportStatus.NEEDS_ACTION]: "needs_confirmation",
  [ReportStatus.NO_ACTION]: "monitoring",
  [ReportStatus.REPORTED]: "actioned",
  [ReportStatus.RESOLVED]: "taken_down",
  [ReportStatus.ARCHIVED]: "archived",
  [ReportStatus.INTERNAL_REVIEW]: "internal_review",
  [ReportStatus.INTERNAL_IGNORED]: "Internal Bad Match",
  [ReportStatus.INTERNAL_ARCHIVED]: "internal_archived",
  [ReportStatus.TESTING]: "testing",
};

export enum ReportClassification {
  UNCLASSIFIED = "unclassified",
  DOWN = "down",
  PARKED = "parked",
  UNRELATED = "unrelated",
  RELATED = "related",
  SUSPICIOUS = "suspicious",
  UNKNOWN = "unknown",
  ACTIVE = "active",
}

export enum ReportSource {
  UI_UPLOAD = "ui_upload",
  API_UPLOAD = "doppel_api",
  ABUSE_BOX = "abuse_box",
  EMAIL_ABUSE_BOX = "email_abuse_box",
  GOOGLE_ADS_TRANSPARENCY = "google_ads_transparency",
  TELEGRAM_USER_SEARCH_API = "telegram_user_search_api",
  SHELLIX_LISTING_SEARCH = "shellix_listing_search",
  URLSCAN_IO = "urlscan_io",
  REDDIT_SUBREDDIT_SEARCH = "reddit_subreddit_search",
  ECX = "ecx",
  GOOGLE_SEARCH = "google_search",
  BAIDU_SEARCH = "baidu_search",
  BING_SEARCH = "bing_search",
  DUCKDUCKGO_SEARCH = "duckduckgo_search",
  YAHOO_SEARCH = "yahoo_search",
  YANDEX_SEARCH = "yandex_search",
  NAVER_SEARCH = "naver_search",
  WHOISXML_SUBDOMAIN = "whoisxml-subdomain",
  DOMAIN_TOOLS_NOH_FEED = "domain_tools_noh_feed",
  DOMAIN_TOOLS_NOH_FQDN_FEED = "domain_tools_noh_fqdn_feed",
  OPENPHISH = "openphish",
  TWITTER_TWEET_SEARCH_API_V2 = "twitter_tweet_search_api_v2",
  ROBLOX_LISTING_SEARCH = "roblox_listing_search",
  TWITTER_USER_SEARCH_API_V1 = "twitter_user_search_api_v1",
  YOUTUBE_CHANNEL_SEARCH = "youtube_channel_search",
  DISCORD_CHANNEL_SEARCH = "discord_channel_search",
  SHELLIX_SEARCH = "shellix_search",
  SECURITY_TRAILS_SEARCH = "security_trails_search",
  TWITTER_API = "twitter_api",
  INSTAGRAM_USER_SCRAPING_APIFY_V0 = "instagram_user_scraping_apify_v0",
  MANUAL_UPLOAD = "manual_upload",
  TWITTER_USER_SCRAPING_APIFY_V0 = "twitter_user_scraping_apify_v0",
  HISTORICAL_REGISTRATION = "historical_registration",
  DARKOWL_SEARCH = "DARKOWL_SEARCH",
  YOUTUBE_LIVE_VIDEO_SEARCH = "youtube_live_video_search",
  DOMAIN_BACKTEST = "domain_backtest",
  DOMAIN_CHALK_EVALUATION = "domain_chalk_evaluation",
  DOMAINS_MONITOR = "domains-monitor",
  TWITTER_TWEET_REPLY_DOMAINS = "twitter_tweet_reply_domains",
  SERP_API = "serp-api",
  SHODAN_SEARCH = "shodan_search",
  TIKTOK_USER_SCRAPING_APIFY_V0 = "tiktok_user_scraping_apify_v0",
  WHOISXML_DOMAIN = "whoisxml-domain",
  MANUAL_SEARCH = "manual_search",
  GOOGLE_SEARCH_ADS = "google_search_ads",
  TWITTER_TWEET_SEARCH_API_V1 = "twitter_tweet_search_api_v1",
  APP_STORE_SCRAPING_APIFY_V0 = "app_store_scraping_apify_v0",
  DARKOWL_EMAIL = "DARKOWL_EMAIL",
  DARKOWL_RANSOMWARE = "DARKOWL_RANSOMWARE",
  INTELX_EMAIL_DOMAIN_API = "INTELX_EMAIL",
  DARKOWL_BIN_API = "DARKOWL_BIN_API",
  DARKOWL_API_LEAKS = "DARKOWL_API_LEAKS",
  PHISH_REPORT = "phish_report",
  CLONED_WEBSITE_EVENT = "cloned_website_event",
  TWITTER_USER_SEARCH_API_V2 = "twitter_user_search_api_v2",
  PHISHING_DATABASE = "phishing-database",
  WHOIS = "whois",
  DOCUMENT_REQUEST = "DOCUMENT_REQUEST",
  INSTAGRAM_USER_SCRAPING = "instagram_user_scraping",
  CERTIFICATE_TRANSPARENCY_LOG = "certificate_transparency_log",
  WHOISXML_STREAMING = "whoisxml_streaming",
  DAILY_REGISTRATION = "daily_registration",
  URLSCAN_IO_TO_PHISHING_FEED = "urlscan_io_phishing_feed",
  URLSCAN_IO_IP_PIVOTING = "urlscan_io_ip_pivoting",
  DNSTWIST = "dnstwist",
  TYPOSQUAT = "typosquat",
  VETRIC = "vetric",
  DOMAINTOOLS = "domaintools",
  FACEBOOK_ADS_APIFY = "facebook_ads_apify",
  VIRUSTOTAL = "virustotal",
  EMAIL_INBOX = "email_inbox",
  JUNK_EMAIL_BUTTON = "junk_email_button",
  PHISHING_EMAIL_BUTTON = "phishing_email_button",
  DOMAIN_TOOLS_IRIS_INVESTIGATE = "domain_tools_iris_investigate",
  DELIST_MONITORING = "delist_monitoring",
  BING_ADS_LIBRARY = "bing_ads_library",
  REVIVAL_MONITORING = "revival_monitoring",
  SCAN_API = "scan_api",
  HYPERLINK_CRAWLER = "hyperlink_crawler",
  SERP_SEARCH_ENGINE = "serp_search_engine",
  REFERRER_LOG = "referrer_log",
}

export const ReportSourceLabels: { [key in ReportSource]?: string } = {
  [ReportSource.UI_UPLOAD]: "analyst_upload",
  [ReportSource.API_UPLOAD]: "analyst_upload",
  [ReportSource.ABUSE_BOX]: "abuse_box",
  [ReportSource.EMAIL_ABUSE_BOX]: "email_abuse_box",
  [ReportSource.GOOGLE_ADS_TRANSPARENCY]: "ads_feed",
  [ReportSource.TELEGRAM_USER_SEARCH_API]: "social_media_api",
  [ReportSource.SHELLIX_LISTING_SEARCH]: "darkweb_feed",
  [ReportSource.URLSCAN_IO]: "web_search_api",
  [ReportSource.REDDIT_SUBREDDIT_SEARCH]: "social_media_api",
  [ReportSource.ECX]: "phishing_feed",
  [ReportSource.GOOGLE_SEARCH]: "web_search_api",
  [ReportSource.BAIDU_SEARCH]: "domains_feed",
  [ReportSource.BING_SEARCH]: "domains_feed",
  [ReportSource.DUCKDUCKGO_SEARCH]: "domains_feed",
  [ReportSource.YAHOO_SEARCH]: "domains_feed",
  [ReportSource.YANDEX_SEARCH]: "domains_feed",
  [ReportSource.NAVER_SEARCH]: "domains_feed",
  [ReportSource.WHOISXML_SUBDOMAIN]: "domains_feed",
  [ReportSource.DOMAIN_TOOLS_NOH_FEED]: "domains_feed",
  [ReportSource.DOMAIN_TOOLS_NOH_FQDN_FEED]: "domains_feed",
  [ReportSource.OPENPHISH]: "phishing_feed",
  [ReportSource.TWITTER_TWEET_SEARCH_API_V2]: "social_media_api",
  [ReportSource.ROBLOX_LISTING_SEARCH]: "marketplace_api",
  [ReportSource.TWITTER_USER_SEARCH_API_V1]: "social_media_api",
  [ReportSource.YOUTUBE_CHANNEL_SEARCH]: "social_media_api",
  [ReportSource.DISCORD_CHANNEL_SEARCH]: "social_media_api",
  [ReportSource.SHELLIX_SEARCH]: "darkweb_feed",
  [ReportSource.SECURITY_TRAILS_SEARCH]: "web_search_api",
  [ReportSource.TWITTER_API]: "social_media_api",
  [ReportSource.INSTAGRAM_USER_SCRAPING_APIFY_V0]: "social_media_api",
  [ReportSource.MANUAL_UPLOAD]: "analyst_upload",
  [ReportSource.TWITTER_USER_SCRAPING_APIFY_V0]: "social_media_api",
  [ReportSource.HISTORICAL_REGISTRATION]: "web_search_api",
  [ReportSource.DARKOWL_SEARCH]: "darkweb_feed",
  [ReportSource.YOUTUBE_LIVE_VIDEO_SEARCH]: "social_media_api",
  [ReportSource.DOMAIN_BACKTEST]: "other",
  [ReportSource.DOMAIN_CHALK_EVALUATION]: "other",
  [ReportSource.DOMAINS_MONITOR]: "domains_feed",
  [ReportSource.TWITTER_TWEET_REPLY_DOMAINS]: "social_media_api",
  [ReportSource.SERP_API]: "web_search_api",
  [ReportSource.SHODAN_SEARCH]: "web_search_api",
  [ReportSource.TIKTOK_USER_SCRAPING_APIFY_V0]: "social_media_api",
  [ReportSource.WHOISXML_DOMAIN]: "domains_feed",
  [ReportSource.MANUAL_SEARCH]: "analyst_upload",
  [ReportSource.GOOGLE_SEARCH_ADS]: "ads_feed",
  [ReportSource.TWITTER_TWEET_SEARCH_API_V1]: "social_media_api",
  [ReportSource.APP_STORE_SCRAPING_APIFY_V0]: "marketplace_api",
  [ReportSource.DARKOWL_EMAIL]: "darkweb_feed",
  [ReportSource.DARKOWL_RANSOMWARE]: "darkweb_feed",
  [ReportSource.INTELX_EMAIL_DOMAIN_API]: "darkweb_feed",
  [ReportSource.DARKOWL_BIN_API]: "darkweb_feed",
  [ReportSource.DARKOWL_API_LEAKS]: "darkweb_feed",
  [ReportSource.PHISH_REPORT]: "phishing_feed",
  [ReportSource.CLONED_WEBSITE_EVENT]: "web_beacon",
  [ReportSource.TWITTER_USER_SEARCH_API_V2]: "social_media_api",
  [ReportSource.PHISHING_DATABASE]: "phishing_feed",
  [ReportSource.WHOIS]: "domains_feed",
  [ReportSource.DOCUMENT_REQUEST]: "darkweb_feed",
  [ReportSource.INSTAGRAM_USER_SCRAPING]: "social_media_api",
  [ReportSource.CERTIFICATE_TRANSPARENCY_LOG]: "certificate_transparency_log",
  [ReportSource.WHOISXML_STREAMING]: "domains_feed",
  [ReportSource.DAILY_REGISTRATION]: "domains_feed",
  [ReportSource.URLSCAN_IO_TO_PHISHING_FEED]: "web_search_api",
  [ReportSource.URLSCAN_IO_IP_PIVOTING]: "pivot",
  [ReportSource.DNSTWIST]: "phishing_feed",
  [ReportSource.TYPOSQUAT]: "phishing_feed",
  [ReportSource.VETRIC]: "social_media_api",
  [ReportSource.DOMAINTOOLS]: "domains_feed",
  [ReportSource.FACEBOOK_ADS_APIFY]: "ads_feed",
  [ReportSource.VIRUSTOTAL]: "domains_feed",
  [ReportSource.EMAIL_INBOX]: "email_inbox",
  [ReportSource.JUNK_EMAIL_BUTTON]: "email_inbox",
  [ReportSource.PHISHING_EMAIL_BUTTON]: "email_inbox",
  [ReportSource.DOMAIN_TOOLS_IRIS_INVESTIGATE]: "domains_feed",
  [ReportSource.DELIST_MONITORING]: "other",
  [ReportSource.BING_ADS_LIBRARY]: "ads_feed",
  [ReportSource.REVIVAL_MONITORING]: "other",
  [ReportSource.SCAN_API]: "phishing_feed",
  [ReportSource.HYPERLINK_CRAWLER]: "crawler",
  [ReportSource.SERP_SEARCH_ENGINE]: "domains_feed",
  [ReportSource.REFERRER_LOG]: "analyst_upload",
};

export enum ReportSourceCategory {
  ANALYST_UPLOAD = "analyst_upload",
  SOCIAL_MEDIA_API = "social_media_api",
  WEB_SEARCH_API = "web_search_api",
  DOMAINS_FEED = "domains_feed",
  PHISHING_FEED = "phishing_feed",
  MARKETPLACE_API = "marketplace_api",
  ADS_FEED = "ads_feed",
  DARKWEB_FEED = "darkweb_feed",
  CERTIFICATE_TRANSPARENCY_LOG = "certificate_transparency_log",
  PIVOT = "pivot",
  ABUSE_BOX = "abuse_box",
  EMAIL_ABUSE_BOX = "email_abuse_box",
  OTHER = "other",
  EMAIL_INBOX = "email_inbox",
  WEB_BEACON = "web_beacon",
  CRAWLER = "crawler",
}

export const ReportSourceCategoryLabels: { [key in ReportSourceCategory]?: string } = {
  [ReportSourceCategory.ANALYST_UPLOAD]: "Analyst Upload",
  [ReportSourceCategory.SOCIAL_MEDIA_API]: "Social Media API",
  [ReportSourceCategory.WEB_SEARCH_API]: "Web Search API",
  [ReportSourceCategory.DOMAINS_FEED]: "Domains Feed",
  [ReportSourceCategory.PHISHING_FEED]: "Phishing Feed",
  [ReportSourceCategory.MARKETPLACE_API]: "Marketplace API",
  [ReportSourceCategory.ADS_FEED]: "Ads Feed",
  [ReportSourceCategory.DARKWEB_FEED]: "Dark Web Feed",
  [ReportSourceCategory.CERTIFICATE_TRANSPARENCY_LOG]: "SSL Transparency Logs",
  [ReportSourceCategory.PIVOT]: "Pivot",
  [ReportSourceCategory.ABUSE_BOX]: "Abuse Box",
  [ReportSourceCategory.EMAIL_ABUSE_BOX]: "Brand Abusebox",
  [ReportSourceCategory.OTHER]: "Other",
  [ReportSourceCategory.EMAIL_INBOX]: "Email Inbox",
  [ReportSourceCategory.WEB_BEACON]: "Web Beacon",
  [ReportSourceCategory.CRAWLER]: "Crawler",
};

export enum SnapshotSource {
  ALERT_CREATE = "alert_create",
  UI_REQUEST = "ui_request",
  DELIST_MONITORING = "delist_monitoring",
  REVIVAL_MONITORING = "revival_monitoring",
}

export enum MissedCaseBuckets {
  NOT_SOURCED = "not_sourced",
  SOURCED_AFTER_MISSED_CASE_CREATION = "sourced_after_missed_case_creation",
  SOURCED_BEFORE_MISSED_CASE_CREATION = "sourced_before_missed_case_creation",
}

export enum PageRoute {
  ALERTS = "/alerts",
  ANALYTICS = "/analytics",
  DOMAINS = "/domains",
  TRADEMARKS = "/trademarks",
  BRANDS = "/brands",
  ORGANIZATIONS = "/admin/organizations",
  UNIFIED_ALERTS = "/admin/alerts",
  AUTOMATED_TAKEDOWNS = "/enforcements/automated-takedowns",
  ENFORCEMENT_TEMPLATES = "/enforcements/enforcement-templates",
  ENFORCEMENT_PLATFORMS = "/enforcements/enforcement-platforms",
  AI_PROMPTS = "/admin/ai-prompts",
  SOURCING_QUERIES = "/detection_tooling/sourcing_queries",
  SCRAPING_CONFIGS = "/detection_tooling/scraping_configs",
  DETECTION_ASSETS = "/detection_tooling/detection_assets",
  DETECTION_RULES = "/detection_tooling/detection_rules",
  DETECTION_CONFIG_APPROVALS = "/detection_tooling/detection_config_approvals",
  MISSED_CASES = "/detection_tooling/missed_cases",
  IOCS = "/detection_tooling/iocs",
  DETECTION_SEARCH = "/detection_tooling/detection_search",
  ENFORCEMENT_FORM_FIELDS = "/enforcements/form-fields",
  SUSPICIOUS_EMAILS = "/employee-abusebox",
  PHISHING_SIM = "/phishing-sim",
  EXECUTIVE_PROTECTION = "/executive-protection",
  THREAT_GRAPH = "/threat-graph",
}

export enum CloudflareReportAbuseErrorCode {
  DUPLICATE = "dedupe",
  URL_NOT_ORANGE = "url_not_orange",
}

export enum AlertSeverity {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export enum EnforcementRequestPlatform {
  METAMASK = "metamask",
  PHANTOM = "phantom",
  GOOGLE = "google",
  COINBASE = "coinbase",
  PUBLIC_DOMAIN_REGISTRY = "public_domain_registry",
  TWITTER = "twitter",
  CLOUDFLARE = "cloudflare",
  VERCEL = "vercel",
  TIKTOK = "tiktok",
  GODADDY = "godaddy",
  INSTAGRAM = "instagram",
  FACEBOOK = "facebook",
  WHATSAPP = "whatsapp",
  NAMECHEAP = "namecheap",
  YOUTUBE = "youtube",
  CLEANDNS = "cleandns",
  FACEBOOK_ADS = "facebook_ads",
}

export enum DomainEnforcementPlatform {
  NAMECHEAP = "namecheap",
  NAMESILO = "namesilo",
  TUCOWS = "tucows",
  PORKBUN = "porkbun",
  PUBLIC_DOMAIN_REGISTRY = "public_domain_registry",
  HOSTINGER = "hostinger",
  SAV = "sav",
  GNAME = "gname",
  DYNADOT = "dynadot",
  NICENIC = "nicenic",
  SAREK_OY = "sarek_oy",
  EPIK = "epik",
  GODADDY = "godaddy",
  CLOUDFLARE = "cloudflare",
  GOOGLE = "google",
  CLEANDNS = "cleandns",
  VERCEL = "vercel",
}

export enum BulkSubmissionExcludedPlatforms {
  GOOGLE_PLAY_STORE = "google_play_store",
  APPLE_APP_STORE = "apple_app_store",
}

export enum EnforcementRequestStatus {
  FAILED = "failed",
  STAGED = "staged",
  BLOCKED = "blocked",
  REPORTED = "reported",
  APPROVED = "approved",
  REJECTED = "rejected",
  REROUTED = "rerouted",
  CANCELED = "canceled",
  RETRACTION_SENT = "retraction_sent",
  RETRACTED = "retracted",
  NO_RESPONSE = "no_response",
}

export const EnforcementRequestStatusLabels: { [key in EnforcementRequestStatus]?: string } = {
  [EnforcementRequestStatus.FAILED]: "staged",
  [EnforcementRequestStatus.STAGED]: "staged",
  [EnforcementRequestStatus.BLOCKED]: "blocked",
  [EnforcementRequestStatus.REPORTED]: "reported",
  [EnforcementRequestStatus.APPROVED]: "approved",
  [EnforcementRequestStatus.REJECTED]: "rejected",
  [EnforcementRequestStatus.REROUTED]: "rerouted",
  [EnforcementRequestStatus.CANCELED]: "canceled",
  [EnforcementRequestStatus.RETRACTION_SENT]: "retraction_sent",
  [EnforcementRequestStatus.RETRACTED]: "retracted",
  [EnforcementRequestStatus.NO_RESPONSE]: "no_response",
};

export enum NamecheapAntiPhishingCaseStatus {
  NEW = 0,
  MANUAL_PROCESSING = 1,
  AUTO_PROCESSED = 2,
  FALSE_POSITIVE = 5,
  FAILED = 6,
  EARLIER_SUSPENDED = 7,
}

export enum WebRiskOperationStatus {
  SUCCEEDED = "SUCCEEDED",
  CLOSED = "CLOSED",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
}

export enum CleanDnsCaseStatus {
  WITH_TARGET = "With Target",
  CLOSED = "Closed",
  SUGGESTED = "Suggested",
  CANCELED = "Canceled",
  EDITING = "Editing",
  DISPOSITION_QUEUE = "Disposition Queue",
  CLIENT_REVIEW = "Client Review",
  DEFERRED = "Deferred",
}

export enum GodaddyCaseStatus {
  RECLASSIFIED = "RECLASSIFIED",
  NOT_REGISTERED_HOSTED_HERE = "NOT_REGISTERED_HOSTED_HERE",
  FORWARDED_COMPLAINT = "FORWARDED_COMPLAINT",
  FALSE_POSITIVE = "FALSE_POSITIVE",
  ACTIONED = "ACTIONED",
}

export enum ReportSortType {
  CREATED_AT = "created_at",
  DATE_LAST_ACTIONED = "date_last_actioned",
}

export const ReportSortTypeLabels: { [key in ReportSortType]?: string } = {
  [ReportSortType.CREATED_AT]: "date_sourced",
  [ReportSortType.DATE_LAST_ACTIONED]: "date_last_actioned",
};

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}

export enum EnforcementEmailType {
  CONFIRMATION = "confirmation",
  INFO_REQUESTED = "info_requested",
  FOLLOW_UP = "follow_up",
  REPLY = "reply",
  ACCEPTANCE = "acceptance",
  REJECTION = "rejection",
  UNKNOWN = "unknown",
  INITIAL_REQUEST = "initial_request",
  REROUTED = "rerouted",
  UNRELATED = "unrelated",
  RE_REPORT_NEEDED = "re_report_needed",
}

export enum EnforcementEmailStatus {
  RECEIVED = "received",
  SENT = "sent",
}

export enum EnforcementEmailStage {
  INITIAL = "initial",
  FOLLOW_UP = "follow_up",
}

export enum ReportChangeEventSource {
  UI = "ui",
  BULK_UI = "bulk_ui",
  DOPPEL_API = "doppel_api",
  DOMAIN_REGEX_RULE = "domain_regex_rule",
  PROFILE_IMAGE_HASH_SIMILARITY = "profile_image_hash_similarity",
  PHISH_REPORT_DETECTION = "phish_report_detection",
  HTML_TITLE_SIMILARITY = "html_title_similarity",
  AUTO_EXPIRE_INTERNAL_ARCHIVE = "auto_expire_internal_archive",
  DELIST_MONITORING = "delist_monitoring",
  REVIVAL_MONITORING = "revival_monitoring",
  SOCIAL_MEDIA_RECLASSIFICATION = "social_media_reclassification",
  DOMAIN_CLASSIFICATION = "domain_classification",
  PROTECTED_ASSET_MATCH = "protected_asset_match",
  PLATFORM_REPORT_REPROCESSING = "platform_report_reprocessing",
  EMAIL_MONITORING = "email_monitoring",
  TRUSTED_REGISTRAR = "trusted_registrar",
  TRUSTED_PLATFORM = "trusted_platform",
  IR_TO_DR_RULE = "ir_to_dr_rule",
  THREAT_TYPE_CLASSIFIER = "threat_type_classifier",
  ALERT_LINKING = "alert_linking",
  AUTOMATED_SAME_ACCOUNT_LINKING = "automated_same_account_linking",
  JIRA = "jira",
  ALERT_SIMILARITY = "alert_similarity",
  ALERT_QUEUE_DECISION = "alert_queue_decision",
  IOC_MATCH = "ioc_match",
  DOMAIN_DETECTION_RULE = "domain_detection_rule",
  RETRO_DOMAIN_DETECTION_RULE = "retro_domain_detection_rule",
  ALERT_CREATION = "alert_creation",
  AUTO_ARCHIVE = "auto_archive",
  RESURFACE_ALERT_SCRIPT = "resurface_alert_script",
  UPDATE_PLATFORM_SUBTYPE_SCRIPT = "update_platform_subtype_script",
  AUTO_ACTIONING = "auto_actioning",
  DUPLICATE_ALERT_DETECTION = "duplicate_alert_detection",
  HANDLE_PARALLELIZED_SCRIPTS = "handle_parallelized_scripts",
  BACKFILL = "backfill",
  TASK_COMPLETION = "task_completion",
  AUTO_UNASSIGN = "auto_unassign",
  WALLET_BLOCK_QUEUE_MOVEMENT = "wallet_block_queue_movement",
  SOCIAL_MEDIA_POST_TAGGING = "social_media_post_tagging",
  SOCIAL_MEDIA_USER_TAGGING = "social_media_user_tagging",
  SUSPECTED_BENIGN_URL_TAGGING = "suspected_benign_url_tagging",
  ENFORCEMENT_STATUS_UPDATED = "enforcement_status_updated",
  ALERT_NEEDS_ACTION = "alert_needs_action",
}

export enum FeatureName {
  SITE_TEXT_TFIDF = "site_text_tfidf",
  DOMAIN_REGISTRAR = "domain_registrar",
  NYCKEL_vafrxvqki46lniiu = "nyckel_vafrxvqki46lniiu",
  NYCKEL_b29ghz4sunis0g34 = "nyckel_b29ghz4sunis0g34",
  NYCKEL_uflpm9h9c3y7ec1d = "nyckel_uflpm9h9c3y7ec1d",
  NYCKEL_w1d3vdy83w8f8mj5 = "nyckel_w1d3vdy83w8f8mj5",
  XGBOOST = "XGBoostAutoGeneratedFeature",
  ORGANIZATION_ID = "organization_id",
  IS_DETECTION_ASSET_URL_GENERIC = "is_detection_asset_url_generic",
  MAX_URL_BRAND_COSINE_SIMILARITY = "max_url_brand_cosine_similarity",
  CONTENT_MALICIOUS_MODEL_SCORE = "content_malicious_model_score",
  TYPOSQUAT_CLASSIFICATION_MODEL_SCORE = "typosquat_classification_model_score",
  CONTENT_MALICIOUS_MODEL_SCORE_V2 = "content_malicious_model_score_v2",
  IS_DOMAIN_CONTAINED_IN_UMBRELLA_LIST = "is_domain_contained_in_umbrella_list",
  URL_CONTAINS_SUSPECTED_BENIGN_KEYWORDS = "url_contains_suspected_benign_keywords",
  URL_CONTAINS_SUSPECTED_BENIGN_FILE_EXTENSION = "url_contains_suspected_benign_file_extension",
  IS_SUSPECTED_BENIGN_REGISTRAR = "is_suspected_benign_registrar",
  IS_SUSPECTED_BENIGN_HOSTING_PROVIDER = "is_suspected_benign_hosting_provider",
  IS_SUSPECTED_BENIGN_URL = "is_suspected_benign_url",
  DOMAIN_REVIVAL_SCORE = "domain_revival_score",
  SITE_TEXT_REGEX = "site_text_regex",
  SITE_URL_REGEX = "site_url_regex",
  SITE_HTML_REGEX = "site_html_regex",
  SCREENSHOT_SIMILARITY = "screenshot_similarity",
  HTML_BRAND_LOGO_SIMILARITY = "html_brand_logo_similarity",
  HTML_FAVICON_SIMILARITY = "html_favicon_similarity",
  HTML_TITLE_SIMILARITY = "html_title_similarity",
  HTML_SSDEEP_HASH_SIMILARITY = "html_ssdeep_hash_similarity",
  MAX_HTML_TITLE_COSINE_SIMILARITY = "max_html_title_cosine_similarity",
  MAX_SITE_TEXT_COSINE_SIMILARITY = "max_site_text_cosine_similarity",
  URL_SIMILARITY_SECOND_LEVEL_DOMAIN_MATCH = "url_similarity_second_level_domain_match",
  URL_SIMILARITY_DOMAIN_SEARCH = "url_similarity_domain_search",
  URL_URL_SIMILARITY = "url_url_similarity",
  URL_FUZZY_KEYWORD_SEARCH = "url_fuzzy_keyword_search",
  URL_KEYWORD_SEARCH = "url_keyword_search",
  URL_DOMAIN_COSINE_SIMILARITY = "url_domain_cosine_similarity",
  MAX_URL_DOMAIN_COSINE_SIMILARITY = "max_url_domain_cosine_similarity",
  MAX_URL_STRING_BRAND_NAME_COSINE_SIMILARITY = "max_url_string_brand_name_cosine_similarity",
  URL_CONTAINS_BRAND_NAME = "url_contains_brand_name",
  URL_BRAND_NAME_PARTIAL_RATIO = "url_brand_name_partial_ratio",
  URL_BRAND_NAME_LEVENSHTEIN_DISTANCE = "url_brand_name_levenshtein_distance",
  MAX_URL_BRAND_DOMAIN_JACCARD_SIMILARITY = "max_url_brand_domain_jaccard_similarity",
  PHISH_REPORT_DETECTION = "phish_report_detection",
  HTML_FORM_DETECTION = "html_form_detection",
  TELEGRAM_LINK_DETECTION = "telegram_link_detection",
  URL_REDIRECT_DETECTION = "url_redirect_detection",
  CRYPTO_WALLET_CONNECT_DETECTION = "crypto_wallet_connection_detection",
  SOCIAL_MEDIA_DISPLAY_NAME_SIMILARITY = "social_media_user_display_name_similarity",
  SOCIAL_MEDIA_USERNAME_SIMILARITY = "social_media_user_username_similarity",
  SOCIAL_MEDIA_USER_PROFILE_IMAGE_SIMILARITY = "social_media_user_profile_image_similarity",
  SOCIAL_MEDIA_USERNAME_BRAND_NAME_SIMILIARITY = "social_media_username_display_name_similarity",
  PROTECTED_ASSET_SLUG_SIMILARITY = "protected_asset_slug_similarity",
  SLUG_SIMILARITY = "slug_similarity",
  PROFILE_NAME_SIMILARITY = "profile_name_similarity",
  SOCIAL_MEDIA_DISPLAY_NAME_SIMILARITY_NORMALIZED = "social_media_display_name_similarity_normalized",
  SOCIAL_MEDIA_DISPLAY_NAME_BRAND_NAME_SIMILARITY_NORMALIZED = "social_media_display_name_brand_name_similarity_normalized",
  SOCIAL_MEDIA_POST_PHYSICAL_THREAT_SCORE = "social_media_post_physical_threat_score",
  SOCIAL_MEDIA_POST_NEGATIVE_SENTIMENT_SCORE = "social_media_post_negative_sentiment_score",
  SOCIAL_MEDIA_CUSTOMER_SERVICE_SCAM_SCORE = "social_media_customer_service_scam_score",
  SOCIAL_MEDIA_JOB_RECRUITING_SCAM_SCORE = "social_media_job_recruiting_scam_score",
  SOCIAL_MEDIA_USERNAME_MEETS_BRAND_NAME_SIMILARITY_THRESHOLD = "social_media_username_meets_brand_name_similarity_threshold",
  SOCIAL_MEDIA_PROFILE_DISPLAY_NAME_MEETS_BRAND_NAME_SIMILARITY_THRESHOLD = "social_media_profile_display_name_meets_brand_name_similarity_threshold",
  SITE_TITLE = "site_title",
  GTAG = "gtag",
  FACEBOOK_TRACKING_PIXEL = "facebook_tracking_pixel",
  MALICIOUS_TRACKING_TAG = "malicious_tracking_tag",
  IP_ADDRESS_MALICIOUSNESS = "malicious_source_ip",
  MALICIOUS_SITE_TITLE = "malicious_site_title",
  URL_SIMILARITY_FILTERING = "url_similarity_filtering",
  URL_SIMILARITY_RANKING = "url_similarity_ranking",
  SITE_TEXT_DIFF_LIB = "site_text_diff_lib",
  TEST = "test",
  AGE = "age",
  WEIGHT = "weight",
  LOOKS_LIKE = "looks_like",
  SMELLS_LIKE = "smells_like",
  JUMP_SCORE = "jump_score",
  CUTENESS = "cuteness",
}

export enum DetectionAssetType {
  BRAND_LOGO = "brand_logo",
  REGEX_SITE_TEXT = "regex_site_text",
  REGEX_URL = "regex_url",
  REGEX_HTML = "regex_html",
  SITE_FAVICON = "site_favicon",
  SITE_SCREENSHOT = "site_screenshot",
  FULL_SITE_SCREENSHOT = "full_site_screenshot",
  MOBILE_SITE_SCREENSHOT = "mobile_site_screenshot",
  MOBILE_FULL_SITE_SCREENSHOT = "mobile_full_site_screenshot",
  SITE_TEXT = "site_text",
  SITE_HTML = "site_html",
  SITE_HTML_SSDEEP_HASH = "site_html_ssdeep_hash",
  SITE_TITLE = "site_title",
  MOBILE_SITE_TEXT = "mobile_site_text",
  MOBILE_SITE_HTML = "mobile_site_html",
  MOBILE_SITE_HTML_SSDEEP_HASH = "mobile_site_html_ssdeep_hash",
  MOBILE_SITE_TITLE = "mobile_site_title",
  URL_SIMILARITY_URL = "url_similarity_url",
  URL_SIMILARITY_KEYWORD = "url_similarity_keyword",
  URL_SIMILARITY_HIGH_PRECISION_KEYWORD = "url_similarity_high_precision_keyword",
  URL_SIMILARITY_FUZZY_KEYWORD = "url_similarity_fuzzy_keyword",
  CUSTOM_RULE = "custom_rule",
  IP_ADDRESS = "ip_address",
  SOCIAL_MEDIA_USER_DISPLAY_NAME = "social_media_user_display_name",
  SOCIAL_MEDIA_USER_PROFILE_IMAGE = "social_media_user_profile_image",
  SOCIAL_MEDIA_USER_USERNAME = "social_media_user_username",
  SOCIAL_MEDIA_USER_BIO = "social_media_user_bio",
  BRAND_NAME = "brand_name",
  GTAG = "gtag",
  FACEBOOK_TRACKING_PIXEL = "facebook_tracking_pixel",
}

export enum DetectionAssetEnabledUsage {
  BRAND_LOGO_DETECTION = "brand_logo_detection",
  SITE_TEXT_FEATURE = "site_text_feature",
  SITE_FAVICON_DETECTION = "site_favicon_detection",
  SITE_SCREENSHOT_DETECTION = "site_screenshot_detection",
  SITE_TEXT_DETECTION = "site_text_detection",
  SITE_HTML_DETECTION = "site_html_detection",
  SITE_TITLE_DETECTION = "site_title_detection",
  URL_SIMILARITY_DETECTION = "url_similarity_detection",
  CUSTOM_RULE_DETECTION = "custom_rule_detection",
  SITE_URL_DETECTION = "site_url_detection",
  IP_ADDRESS_DETECTION = "ip_pivoting",
  SOCIAL_MEDIA_USER_DISPLAY_NAME_DETECTION = "social_media_user_display_name_similarity_detection",
  SOCIAL_MEDIA_USER_PROFILE_IMAGE_DETECTION = "social_media_user_profile_image_similarity_detection",
  SOCIAL_MEDIA_USER_BIO_DETECTION = "social_media_user_bio_similarity_detection",
  SOCIAL_MEDIA_USER_USERNAME_DETECTION = "social_media_user_username_similarity_detection",
  SOCIAL_MEDIA_BRAND_NAME_DETECTION = "social_media_brand_name_detection",
  IOC_PIVOTING = "ioc_pivoting",
  CRED_THEFT_DETECTION = "cred_theft_detection",
}

export enum DetectionAssetOriginatorType {
  BRAND = "brand",
  PROTECTED_ASSET = "protected_asset",
  USER = "user",
  IOC = "ioc",
  FULL_URL = "full_url",
  SOCIAL_MEDIA = "social_media",
  MOBILE_APP = "mobile_app",
  ALERT = "alert",
}

export enum DetectionAssetIrToDrRule {
  DISABLED = "disabled",
  EXACT_MATCH = "exact_match",
  PARTIAL_MATCH_95 = "partial_match_95",
}

export enum DetectionAssetCreationMethod {
  AUTO_GENERATED_FROM_BRAND = "auto_generated_from_brand",
  AUTO_GENERATED_FROM_IOC = "auto_generated_from_ioc",
  AUTO_GENERATED_FROM_PROTECTED_ASSET = "auto_generated_from_protected_asset",
  AUTO_GENERATED_FROM_CUSTOMER_ASSET = "auto_generated_from_customer_asset",
  AUTO_GENERATED_FROM_ALERT = "auto_generated_from_alert",
  UI_URL_UPLOAD = "ui_url_upload",
  USER_UPLOAD_FROM_FILE = "user_upload_from_file",
}

export enum CustomerType {
  STANDARD = "standard",
  CRYPTO = "crypto",
}

export enum PubSubTopic {
  DELIST_MONITORING = "delist_monitoring",
  DELIST_MONITORING_V2 = "delist_monitoring_v2",
  DELIST_MONITORING_TEMP = "delist_monitoring_temp",
  SOURCING = "sourcing",
  DOMAIN_SIGNAL_PROCESSING = "domain_signal_processing",
  DOMAIN_CANDIDATE_PROCESSING = "domain_candidate_processing",
  ENFORCEMENT_STATUS_RESOLUTION = "enforcement_status_resolution",
  EMAIL_MONITORING = "email_monitoring",
  AUTO_REPORTING_VALIDATION = "auto_reporting_validation",
  AUTO_REPORTING_SUBMISSION = "auto_reporting_submission",
}

export enum CloudTaskQueue {
  DELIST_CLOUD_TASKS_QUEUE = "delist-monitoring",
  SOURCING_CLOUD_TASKS_QUEUE = "sourcing",
  DOMAIN_THROTTLER_TASKS_QUEUE = "domain-throttler",
  ENFORCEMENT_STATUS_RESOLUTION = "enforcement-status-resolution",
  EMAIL_MONITORING = "email-monitoring",
  AUTO_REPORTING_VALIDATION = "auto-reporting-validation",
}

export enum DelistSelectionMethod {
  CLOUD_TASK = "cloud_task",
  PUBSUB = "pubsub",
}

export enum AutoStagingDisabledMultiplePlatforms {
  ALL = "cleanDNS and all auto-staging",
  ALL_CRYPTO = "all crypto wallet blocking",
}

export enum AutoStagingDisabledReason {
  PRODUCT_TYPE_NOT_DOMAIN = "auto-staging not enabled for this product. Please continue creating enforcements as normal using the established playbook",
  FLAGGED_URL_HAS_PATH = "flagged url has a path. Please report phishing directly to the host domain/platform of the flagged url",
  FLAGGED_URL_HAS_EXACT_PLATFORM = "flagged url is an exact match with a platform domain. Please do not generate any enforcements (manual or auto) for this report",
  ENFORCEMENT_TYPE_NOT_PHISHING = "enforcement type is not phishing. If you wish to auto-stage phishing enforcements, please change enforcement type to phishing",
  ENFORCMENT_METADATA_NO_LEGAL_NAME = "enforcement metadata does not have legal_name. Please add the legal name for the organization using the admin organizations page",
  FLAGGED_URL_HAS_PLATFORM = "flagged url's root or host is a platform domain. Please create a phishing enforcement for the matching platform",
  DISABLED_HOST_OR_REGISTRAR = "auto-staging is disabled for this host or registrar. Please manually stage phishing enforcements requests to the host and/or registrar",
  NOT_CRYPTO_CUSTOMER = "customer type is not crypto. To switch customer type, use admin organizations page",
  PLATFORM_ENFORCEMENT_ALREADY_ACTIVE = "active enforcement already exists for the platform. Consider checking on the status of the existing request for the platform or blocking and re-reporting",
  ENFORCEMENT_ALREADY_STAGED = "enforcement already staged for the platform in the Domains Takedown Request Form. Please continue reviewing enforcements as normal",
  IP_ADDRESS_FOUND = "flagged url contains IP address. No further action required",
}

export enum AutoStagingDisabledParamName {
  FLAGGED_URL = "flagged url",
  MATCHING_PLATFORM = "matching platform",
  DETECTED_PATH = "detected path",
  CUSTOMER_TYPE = "customer type",
  PRODUCT_TYPE = "product type",
  ENFORCEMENT_TYPE = "enforcement type",
  HOSTING_PROVIDER = "hosting provider",
  REGISTRAR_NAME = "registrar name",
  HOST_DOMAIN = "host domain",
  URL_TYPE = "url type",
  SUPPORTED_URL_TYPES = "supported url types",
}

export enum StatsDateFilters {
  LAST_DAY = "last_day",
  LAST_WEEK = "last_week",
  LAST_MONTH = "last_month",
  LAST_3_MONTHS = "last_3_months",
  LAST_6_MONTHS = "last_6_months",
}

export const StatsDateFiltersLabels: { [key in StatsDateFilters]?: string } = {
  [StatsDateFilters.LAST_DAY]: "Last 24 Hours",
  [StatsDateFilters.LAST_WEEK]: "Last 7 Days",
  [StatsDateFilters.LAST_MONTH]: "Last 30 Days",
  [StatsDateFilters.LAST_3_MONTHS]: "Last 3 Months",
  [StatsDateFilters.LAST_6_MONTHS]: "Last 6 Months",
};

export enum StatsDateBucketInterval {
  HOURLY = "hourly",
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export enum SourcerLabel {
  DOMAINS_DOMAIN_MONITOR = "domains_domain_monitor",
  DOMAINS_DOMAIN_OPENPHISH = "domains_domain_openphish",
  DOMAINS_DOMAIN_PHISHING_DATABASE = "domains_domain_phishing_database",
  DOMAINS_DOMAIN_SECURITY_TRAILS_SEARCH = "domains_domain_security_trails_search",
  DOMAINS_DOMAIN_URLSCAN_IO_KEYWORD = "domains_domain_urlscan_io_keyword",
  DOMAINS_DOMAIN_URLSCAN_IO_QUERY = "domains_domain_urlscan_io_query",
  DOMAINS_DOMAIN_URLSCAN_IO_QUERY_HOSTNAME_SOURCE = "domains_domain_urlscan_io_query_hostname_source",
  DOMAINS_DOMAIN_WHOIS_DOMAIN = "domains_domain_whois_domain",
  DOMAINS_DOMAIN_WHOISXML_DOMAIN = "domains_domain_whoisxml_domain",
  DOMAINS_DOMAIN_WHOISXML_SUBDOMAIN = "domains_domain_whoisxml_subdomain",
  DOMAINS_DOMAIN_GOOGLE_SEARCH = "domains_domain_google_search",
  DOMAINS_DOMAIN_ECX = "domains_domain_ecx",
  DOMAINS_DOMAIN_SHODAN_SEARCH = "domains_domain_shodan_search",
  DOMAINS_DOMAIN_URLSCAN_IO_PHISHING_FEED = "domains_domain_urlscan_io_phishing_feed",
  DOMAINS_DOMAIN_DNSTWIST = "domains_domain_dnstwist",
  DOMAINS_DOMAIN_TYPOSQUAT = "domains_domain_typosquat",
  DOMAINS_DOMAIN_VIRUSTOTAL_URL_FEED = "domains_domain_virustotal_url_feed",
  DOMAINS_DOMAIN_TOOLS_IRIS_INVESTIGATE = "domains_domain_tools_iris_investigate",
  DOMAINS_DOMAIN_DOMAIN_TOOLS_NOH_FEED = "domains_domain_domain_tools_noh_feed",
  DOMAINS_DOMAIN_SERP_SEARCH_ENGINE = "domains_domain_serp_search_engine",
  DOMAINS_DOMAIN_CERTIFICATE_TRANSPARENCY_SEARCH = "domains_domain_certificate_transparency_search",
  MOBILE_APPS_GOOGLE_PLAY_STORE_SERP = "mobile_apps_google_play_store_serp",
  MOBILE_APPS_APPLE_APP_STORE_SERP = "mobile_apps_apple_app_store_serp",
  MOBILE_APPS_APIFY_APP_STORES_APIFY = "mobile_apps_apify_app_stores_apify",
  SOCIAL_MEDIA_TIKTOK_APIFY = "social_media_tiktok_apify",
  SOCIAL_MEDIA_TWITTER_USER_SEARCH = "social_media_twitter_user_search",
  SOCIAL_MEDIA_YOUTUBE_CHANNEL_SEARCH = "social_media_youtube_channel_search",
  SOCIAL_MEDIA_YOUTUBE_LIVE_VIDEO_SEARCH = "social_media_youtube_live_video_search",
  SOCIAL_MEDIA_TWITTER_VETRIC = "social_media_twitter_vetric",
  SOCIAL_MEDIA_FACEBOOK_VETRIC = "social_media_facebook_vetric",
  SOCIAL_MEDIA_FACEBOOK_PAGE_VETRIC = "social_media_facebook_page_vetric",
  SOCIAL_MEDIA_INSTAGRAM_VETRIC = "social_media_instagram_vetric",
  SOCIAL_MEDIA_INSTAGRAM_ACCOUNTS_VETRIC = "social_media_instagram_accounts_vetric",
  SOCIAL_MEDIA_TIKTOK_USER_VETRIC = "social_media_tiktok_user_vetric",
  SOCIAL_MEDIA_TWITTER_POSTS_LATEST_VETRIC = "social_media_twitter_posts_latest_vetric",
  SOCIAL_MEDIA_TWITTER_POSTS_MONITOR_TWEET_REPLIES = "social_media_twitter_posts_monitor_tweet_replies",
  SOCIAL_MEDIA_TWITTER_POSTS_MONITOR_PROTECTED_ACCOUNT = "social_media_twitter_posts_monitor_protected_account",
  SOCIAL_MEDIA_FACEBOOK_POSTS = "social_media_facebook_posts",
  SOCIAL_MEDIA_FACEBOOK_GROUPS = "social_media_facebook_groups",
  DARKWEB_DARKWEB_DARKOWL_EMAIL = "darkweb_darkweb_darkowl_email",
  DARKWEB_DARKWEB_DARKOWL_RANSOMWARE = "darkweb_darkweb_darkowl_ransomware",
  DARKWEB_DARKWEB_DARKOWL_SEARCH = "darkweb_darkweb_darkowl_search",
  DARKWEB_DARKWEB_DARKOWL_API_LEAKS = "darkweb_darkweb_darkowl_api_leaks",
  DARKWEB_DARKWEB_INTELX_EMAIL = "darkweb_darkweb_intelx_email",
  DARKWEB_CREDIT_CARD_LEAK_DARKOWL_ENTITY = "darkweb_credit_card_leak_darkowl_entity",
  PAID_ADS_GOOGLE_ADS_SERP = "paid_ads_google_ads_serp",
  PAID_ADS_FACEBOOK_ADS_APIFY = "paid_ads_facebook_ads_apify",
  PAID_ADS_BING_ADS_LIBRARY = "paid_ads_bing_ads_library",
  PAID_ADS_DOMAINS_PASSIVE_PIVOT = "paid_ads_domains_passive_pivot",
  DARKMARKET_SHELLIX_LISTING_SEARCH = "darkmarket_shellix_listing_search",
}

export enum EnforcementUrlType {
  MALICIOUS = "malicious",
  COMPROMISED = "compromised",
  BUILDER = "builder",
  SHORTENER = "shortener",
}

export enum DomainsEnforcementType {
  PHISHING = "phishing",
  TRADEMARK = "trademark",
  COPYRIGHT = "copyright",
}

export enum AppsEnforcementType {
  DMCA = "dmca",
  TRADEMARK = "trademark",
}

export enum EnforcementType {
  DMCA = "dmca",
  TRADEMARK = "trademark",
  PHISHING = "phishing",
  COPYRIGHT = "copyright",
  COUNTERFEIT = "counterfeit",
  PRODUCT_MISUSE = "product_misuse",
  IMPERSONATION = "impersonation",
  WALLET_BLOCK = "wallet_block",
}

export enum TrademarkStatus {
  ACTIVE = "active",
  PENDING = "pending",
  INACTIVE = "inactive",
  INVALID = "invalid",
}

export enum NotificationType {
  PERIODIC_NOTIFICATION = "periodic_notification",
}

export enum NotificationPlatformType {
  EMAIL = "email",
  SLACK = "slack",
}

export enum NotificationFrequencyType {
  DAILY = "daily",
  WEEKLY = "weekly",
  BIWEEKLY = "biweekly",
  MONTHLY = "monthly",
}

export enum NotificationReportType {
  REPORT_STATUS_CHANGES = "report_status_changes",
}

export enum EnforcementMethod {
  MANUAL_FORM = "manual_form",
  MANUAL_EMAIL = "manual_email",
  AUTO_FORM = "auto_form",
  AUTO_EMAIL = "auto_email",
  API = "api",
  OTHER = "other",
}

export const EnforcementMethodLabels: { [key in EnforcementMethod]?: string } = {
  [EnforcementMethod.MANUAL_FORM]: "MANUAL",
  [EnforcementMethod.MANUAL_EMAIL]: "MANUAL",
  [EnforcementMethod.AUTO_FORM]: "AUTO_FORM",
  [EnforcementMethod.AUTO_EMAIL]: "AUTO_API",
  [EnforcementMethod.API]: "AUTO_API",
  [EnforcementMethod.OTHER]: "MANUAL",
};

export enum EnforcementMethodStage {
  INITIAL = "initial",
  ESCALATION = "escalation",
}

export enum EnforcementPlatformType {
  BUILDER = "builder",
  SHORTENER = "shortener",
  COUNTRY_CODE_TLD = "cc_tld",
  GENERIC_TLD = "generic_tld",
  REGISTRAR = "registrar",
  HOSTING_PROVIDER = "hosting_provider",
  WEBSITE_OWNER = "website_owner",
  UNKNOWN_TLD = "tld",
  CRYPTO_BLOCKER = "crypto_wallet",
  SITE_BLOCKER = "site_blocker",
  REGISTRY_TAKEDOWN_PROVIDER = "registry_takedown_provider",
}

export const EnforcementPlatformTypeLabels: { [key in EnforcementPlatformType]?: string } = {
  [EnforcementPlatformType.BUILDER]: "website builder",
  [EnforcementPlatformType.SHORTENER]: "URL shortener",
  [EnforcementPlatformType.COUNTRY_CODE_TLD]: "country code TLD",
  [EnforcementPlatformType.GENERIC_TLD]: "TLD registry",
  [EnforcementPlatformType.REGISTRAR]: "registrar",
  [EnforcementPlatformType.HOSTING_PROVIDER]: "hosting provider",
  [EnforcementPlatformType.WEBSITE_OWNER]: "website owner",
  [EnforcementPlatformType.UNKNOWN_TLD]: "TLD",
  [EnforcementPlatformType.CRYPTO_BLOCKER]: "crypto blocker",
  [EnforcementPlatformType.SITE_BLOCKER]: "site blocker",
  [EnforcementPlatformType.REGISTRY_TAKEDOWN_PROVIDER]: "registry takedown provider",
};

export enum AppEnforcementPlatformType {
  LEGITIMATE = "legitimate",
  THIRD_PARTY_APK = "third_party_apk",
}

export const AppEnforcementPlatformTypeLabels: { [key in AppEnforcementPlatformType]?: string } = {
  [AppEnforcementPlatformType.LEGITIMATE]: "legitimate",
  [AppEnforcementPlatformType.THIRD_PARTY_APK]: "third party APK",
};

export enum PaidAdsEnforcementPlatformType {
  AD_PROVIDER = "ad_provider",
}

export const PaidAdsEnforcementPlatformTypeLabels: { [key in PaidAdsEnforcementPlatformType]?: string } = {
  [PaidAdsEnforcementPlatformType.AD_PROVIDER]: "ad_provider",
};

export enum EnforcementPlatformSource {
  REGISTRAR_NAME = "report registrar name",
  HOSTING_PROVIDER = "report hosting provider",
  FLAGGED_URL_TLD = "flagged url top level domain",
  FLAGGED_URL_ROOT = "flagged url root domain",
  FLAGGED_URL_HOST = "flagged url host domain",
  AUTO_STAGING = "auto staging",
  USER = "user",
}

export enum StatsQueryOptions {
  BRAND = "brand",
  SOURCE = "source",
  PRODUCT = "product",
  GROUP_BY = "group_by",
  DATE_RANGE = "date_range",
  TAG = "tag",
  UPLOADER = "uploader",
  PROVIDER = "provider",
  REGISTRAR = "registrar",
  TAGS = "tags",
  PLATFORMS = "platforms",
  PLATFORM = "platform",
  PASSWORD_TYPE = "password_type",
  DARK_WEB_LEAK_CONTENTS = "dark_web_leak_contents",
  EMAIL_REGEX = "email_regex",
  PASSWORD_COMPLEXITY = "password_complexity",
}

export enum StatsGraphNames {
  REPORTS_SURFACED = "reports_surfaced",
  MEDIAN_TAKEDOWN_TIME = "median_takedown_time",
}

export enum StagingDisabledReason {
  MISSING_ENFORCEMENT_TYPE = "Enforcement type is required",
  MISSING_PLATFORM = "Enforcement platform is required",
  MISSING_SCREENSHOT = "Manual enforcement requires a screenshot",
  MISSING_CUSTOM_PLATFORM_NAME = "Custom platform requires a name",
  MISSING_ENFORCEMENT_METHOD = "Enforcement method is required",
  REQUEST_ALREADY_EXISTS = "An enforcement request for the same platform and type already exists",
  MISSING_PLATFORM_TYPE = "Enforcement platform type is required",
  MISSING_TRADEMARK = "Selecting trademark for trademark enforcements is required",
  MISSING_CONTENT_TYPE = "Selecting content type for social media enforcements is required",
  REACHED_ENFORCEMENT_LIMIT = "Cannot submit more than 7 enforcements to the same platform",
  ENFORCEMENT_PLATFORM_MALICIOUS = "Enforcement platform is malicious. Do not submit enforcement.",
}

export enum AIPromptType {
  REPORT_ACTION_SUGGESTION = "report_action_suggestion",
  ALERT_QUEUE_ACTION = "alert_queue_action",
  EMAILS_SENTIMENT_ANALYSIS = "emails_sentiment_analysis",
  EMAILS_HEADER_ANALYSIS = "emails_header_analysis",
  ZEUS_BOT_CODE_ANALYSIS = "zeus_bot_code_analysis",
  SOURCING_QUERY_GENERATION = "sourcing_query_generation",
  ALERT_CREATION_RULE_GENERATION = "alert_creation_rule_generation",
  EMAIL_MONITORING_ANALYSIS = "email_monitoring_analysis",
  ALERT_ENFORCEMENT_TYPE_CLASSIFICATION = "alert_enforcement_type_classification",
  IOC_VALIDATION = "ioc_validation",
  TYPOSQUAT_ANALYSIS = "typosquat_analysis",
  SCREENSHOT_COMPARISON = "screenshot_comparison",
  SM_ALERT_QUEUE_ACTION = "sm_alert_queue_action",
  PHISHING_SIM_EMAIL_GENERATION = "phishing_sim_email_generation",
}

export enum AILangsmithPromptName {
  SCREENSHOT_COMPARISON = "screenshot_comparison_sf",
  TYPOSQUAT_ANALYSIS = "typosquat_analysis",
  SITE_TEXT_ANALYSIS = "site_text_analysis",
  PAID_ADS = "paid_ads",
  SCREENSHOT_PREDICTED_ENFORCEMENT_TYPE_DOMAINS = "domains_predicted_enforcement_type_screenshot_v2",
  SITE_TEXT_PREDICTED_ENFORCEMENT_TYPE_DOMAINS = "domains_predicted_enforcement_type_site_text_v2",
}

export enum AIPromptPlatform {
  DOMAIN = "domain",
  TWITTER = "twitter",
  SOCIAL_MEDIA = "social_media",
  SOCIAL_MEDIA_PROFILE = "social_media_profile",
  SOCIAL_MEDIA_GROUP = "social_media_group",
  SOCIAL_MEDIA_POST = "social_media_post",
}

export enum AIPromptRole {
  USER = "user",
  SYSTEM = "system",
}

export enum AIPromptMetadataKey {
  ORG_PROMPT = "org_prompt",
  BASE_PROMPT = "base_prompt",
}

export enum OrganizationMetadataKey {
  TRIAL_TAKEDOWN_LIMIT = "trial_takedown_limit",
}

export enum ApiName {
  DARKOWL = "darkowl",
  DOMAIN_TOOLS_IRIS_INVESTIGATE = "domain_tools_iris_investigate",
}

export enum RateLimitInterval {
  MINUTE = "minute",
  HOUR = "hour",
  DAY = "day",
  MONTH = "month",
}

export enum RateLimitProtocol {
  BREAK = "break",
  WAIT = "wait",
}

export enum ReportActions {
  REPORT = "REPORT",
  MONITOR = "MONITOR",
  ASK_FOR_CONFIRMATION = "ASK_FOR_CONFIRMATION",
  NO_ACTION = "NO_ACTION",
}

export const ReportActionsLabels: { [key in ReportActions]?: string } = {
  [ReportActions.REPORT]: "Report",
  [ReportActions.MONITOR]: "Move to Monitoring",
  [ReportActions.ASK_FOR_CONFIRMATION]: "Move to Needs Confirmation",
  [ReportActions.NO_ACTION]: "No action",
};

export enum SuggestedEnforcementDisabledReason {
  DEDUPE_TLD = "Enforcement already generated for TLD registry. (TLD can be either generic or country code, not both).",
  UNSUPPORTED_ENFORCEMENT_TYPES = "Platform does not support these enforcement types.",
  ACTIVE_ENFORCEMENT_ALREADY_EXISTS = "Active enforcement already exists for the platform(s).",
  UNSUPPORTED_TLD = "Flagged URL TLD is not a reportable TLD platform.",
  ALREADY_STAGED_IN_DOMAINS_TAKEDOWN_FORM = "Enforcement already staged in Takedown Form.",
  FLAGGED_URL_HAS_PATH = "Flagged url has a path.",
  ENFORCEMENT_TYPE_NOT_PHISHING = "Phishing not selected as an enforcement type in suggested enforcements form.",
  ENFORCEMENT_METADATA_NO_LEGAL_NAME = "Enforcement metadata does not have legal_name.",
  FLAGGED_URL_HAS_PLATFORM = "Flagged url's root or host is a platform domain.",
  DISABLED_HOST_OR_REGISTRAR = "CleanDNS enforcements are disabled for this host/registrar.",
  NOT_CRYPTO_CUSTOMER = "Customer type is not crypto.",
  URL_TYPE_NOT_MALICIOUS = "Url type selected in suggested enforcements form is not malicious.",
  IP_ADDRESS = "Flagged url contains IP address.",
  CRYPTO_WALLET_BLOCKING_NOT_SELECTED = "Crypto wallet blocking was unselected in Suggested Enforcements Form.",
  NOT_CLEANDNS_SUPPORTED = "Registrar and TLD not supported by CleanDNS.",
  MULTIPLE_ENFORCEMENTS_NOT_ALLOWED = "Cannot submit enforcement multiple times to the platform(s).",
  ALREADY_CREATED_CLEANDNS_ENFORCEMENT = "Already created CleanDNS enforcement for the platform type.",
  URL_TYPE_NOT_SUPPORTED = "Url type selected in suggested enforcements form is not supported for the platform(s).",
  ALREADY_STAGED_IN_SUGGESTED_ENFORCEMENTS = "Enforcement already staged in Suggested Enforcements Display.",
  ENFORCEMENT_PLATFORM_MALICIOUS = "Enforcement platform is malicious.",
  LIMIT_REACHED_STALE_ENFORCEMENTS = "Reached limit for number of enforcements to the same platform.",
}

export enum SuggestedEnforcementDisabledAction {
  NO_ACTION = "No further action required.",
  BLOCK_AND_REREPORT = "Check status of existing request, or block and re-report",
  RESUBMIT_FORM_WITH_MALICIOUS = "If URL is malicious, re-submit suggested enforcements form",
  RESUBMIT_FORM_WITH_PHISHING = "If you want to auto-stage phishing enforcements, re-submit suggested enforcements form",
  RESUBMIT_FORM_WITH_CRYPTO_WALLET_BLOCKING = "If you want to auto-stage crypto wallet blocking enforcements, re-submit suggested enforcement form",
  ADD_ORG_LEGAL_NAME = "Add org's legal name in admin organizations page and re-submit suggested enforcements form.",
  REPORT_TO_FLAGGED_URL_HOST = "Review & submit phishing enforcement for host/platform of flagged url",
  REVIEW_HOST_REGISTRAR_ENFORCEMENT = "Review & submit phishing enforcement to corresponding host/registrar.",
  SWITCH_CUSTOMER_TYPE = "If you want to submit crypto wallet blocking enforcements, switch customer type in admin organizations page.",
  FOLLOWUP_ORIGINAL = "Please followup on the original request to the platform(s).",
  RESUBMIT_FORM_WITH_URL_TYPE = "If you think URL type is incorrect, re-submit suggested enforcements form",
  AVOID_DUPLICATION = "To avoid duplicate requests, please reject this enforcement or select another platform.",
}

export enum SuggestedEnforcementDisabledParamName {
  FLAGGED_URL_TLD = "flagged url tld",
  ALREADY_GENERATED_TLD_TYPE = "tld type already generated for",
  PLATFORM = "platform(s)",
  UNSUPPORTED_ENFORCEMENT_TYPES = "unsupported enforcement type(s)",
}

export enum PlatformSelectionMethod {
  MATCHED_STRING = "Matched String",
  UNKNOWN = "Unknown",
  CLEANED_REPORT_FIELD = "Cleaned Report Field",
  PLATFORM_KNOWN = "Platform Known",
  CUSTOM = "Custom",
  PLATFORM_PICKER = "Platform Picker",
  MATCHED_PLATFORM_IDENTIFIER = "Matched Platform Identifier",
}

export enum MatchAttributionType {
  DETECTION_ASSET = "detection_asset",
  SOURCING_QUERY = "sourcing_query",
  SOURCING_EXECUTION = "sourcing_execution",
  IR_TO_DR_RULE = "ir_to_dr_rule",
  DETECTION_RULE = "detection_rule",
}

export enum TagActionType {
  ADD = "add",
  REMOVE = "remove",
}

export enum AutoActionTypeReportTag {
  PHISHING = "Phishing",
  COPYRIGHT = "Copyright",
  TRADEMARK = "Trademark",
  WALLET_BLOCK = "Wallet_Block",
  DMCA = "DMCA",
}

export enum FileActionType {
  UPLOAD = "upload",
  DELETE = "delete",
}

export enum ScriptServiceType {
  REPORT_UNBUNDLING = "report_unbundling",
  BACKFILL_EXTERNAL_IDS = "backfill_external_ids",
  BACKFILL_FULL_URL_SCREENSHOTS = "backfill_full_url_screenshots",
  BACKFILL_SOCIAL_MEDIA_DATA_SCREENSHOTS = "backfill_social_media_data_screenshots",
  BACKFILL_REPORT_LEVEL_SCREENSHOTS = "backfill_report_level_screenshots",
  BACKFILL_MOBILE_APP_SCREENSHOTS = "backfill_mobile_app_screenshots",
  BACKFILL_SPOOF_STATUS = "backfill_spoof_status",
  BACKFILL_PLATFORM_SUBTYPES = "backfill_platform_subtypes",
  BACKFILL_ML_FEATURES_FOR_ANALYSIS = "backfill_features_for_pivoting_analysis",
  BATCH_RUN_ALERTS = "batch_run_alerts",
  BACKFILL_COUNTRY_CODES = "backfill_country_codes",
  MERGE_SOCIAL_MEDIA_DATA_ROWS = "merge_social_media_data_rows",
  BACKFILL_IS_CUSTOMER_SOURCED = "backfill_is_customer_sourced",
  DELETE_INTERNAL_ARCHIVE = "delete_internal_archive",
  BACKFILL_LAST_ACTIVITY_TIMESTAMP = "backfill_last_activity_timestamp",
  BACKFILL_SNAPSHOTS = "backfill_snapshots",
  FIX_ALERT_TYPE = "fix_alert_type",
  MOVE_ALERTS_TO_QUEUE = "move_alerts_to_queue",
  BACKFILL_UNIVERSAL_ENTITY_ID = "backfill_universal_entity_id",
}

export enum AlertLinkType {
  HYPERLINK = "hyperlink",
  REDIRECT = "redirect",
  SAME_ROOT_DOMAIN = "same_root_domain",
  OTHER = "other",
  SAME_IDENTIFIER = "same_identifier",
  HTML_SIMILARITY = "html_similarity",
}

export enum AlertLinkRelationship {
  PARENT_CHILD = "parent_child",
  PEER_TO_PEER = "peer_to_peer",
  PARENT = "parent",
  CHILD = "child",
}

export enum AlertLinkStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export enum ThreatType {
  DOMAIN = "domain",
  URL = "url",
  DOMAIN_AND_URL = "domain_and_url",
  PAYLOAD = "payload",
  LINK = "link",
  RESPONSE = "response",
}

export enum AttackType {
  CREDENTIAL_THEFT = "credential_theft",
  REDIRECT = "redirect",
  BRAND_INFRINGEMENT = "brand_infringement",
  TYPOSQUATTED_DOMAIN = "typosquatted_domain",
  PHYSICAL_THREAT = "physical_threat",
  NEGATIVE_SENTIMENT = "negative_sentiment",
  SUPPORT_SCAM = "support_scam",
  JOB_RECRUITING_SCAM = "job_recruiting_scam",
}

export enum AttackSubtype {
  MALWARE = "e86875fe-2910-4123-8eac-4efc3cd7e075",
  DOCUPHISH = "2cdfd08f-5208-4d9f-bc47-2252ab905857",
  BUSINESS_INFRASTRUCTURE = "4ffff68c-4bfb-451f-9fbf-85f7beeb72da",
  BRAND_TARGETED = "37e7d1f9-ae48-4742-b05c-b4dfe8edb8b0",
  IMPERSONATION_OF_EMPLOYEE = "5b7c55a7-caf4-4d98-8302-e7dc2bc21ab1",
  IMPERSONATION_OF_SERVICES = "2a895e6a-e166-4755-949d-67a79e6ddc48",
  IMPERSONATION_OF_BUSINESS = "983fdb88-2336-44e7-b2dc-af5f64993d62",
  HOAX = "b8c30b3e-6bda-4fe6-b7b6-7b04f8840d99",
}

export const AttackSubtypeLabels: { [key in AttackSubtype]?: string } = {
  [AttackSubtype.MALWARE]: "Malware",
  [AttackSubtype.DOCUPHISH]: "Docuphish",
  [AttackSubtype.BUSINESS_INFRASTRUCTURE]: "Business Infrastructure",
  [AttackSubtype.BRAND_TARGETED]: "Brand Targeted",
  [AttackSubtype.IMPERSONATION_OF_EMPLOYEE]: "Impersonation of Employee",
  [AttackSubtype.IMPERSONATION_OF_SERVICES]: "Impersonation of Services",
  [AttackSubtype.IMPERSONATION_OF_BUSINESS]: "Impersonation of Business",
  [AttackSubtype.HOAX]: "Hoax",
};

export enum CRUDActionType {
  GET = "get",
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
  UPSERT = "upsert",
}

export enum OrganizationStatus {
  ACTIVE = "active",
  EVALUATING = "evaluating",
  PITCHING = "pitching",
  TRIAL_ENDED = "trial_ended",
  INACTIVE = "inactive",
  TEST_ORG = "test_org",
}

export const OrganizationStatusLabels: { [key in OrganizationStatus]?: string } = {
  [OrganizationStatus.ACTIVE]: "active",
  [OrganizationStatus.EVALUATING]: "trial",
  [OrganizationStatus.PITCHING]: "demo",
  [OrganizationStatus.TRIAL_ENDED]: "trial_ended",
  [OrganizationStatus.INACTIVE]: "inactive",
  [OrganizationStatus.TEST_ORG]: "test_org",
};

export enum SourcingQueryStatus {
  PREVIEW = "preview",
  ACTIVE = "active",
  DISABLED = "disabled",
}

export enum DCPPriority {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export enum DCPExperiment {
  REPORT_CREATION_FILTER_MODEL = "report_creation_filter_model",
  SCRAPING = "scraping",
  CONTENT_MALICIOUS_SCORING_MODEL = "content_malicious_scoring_model",
  TYPOSQUAT_CLASSIFICATION_MODEL = "typosquat_classification_model",
}

export enum GenerateSuggestedEnforcementsMode {
  SUGGESTED_ENFORCEMENT_FORMS = "suggested_enforcement_forms",
  SINGLE_ENFORCEMENT = "single_enforcement",
}

export enum SuggestedEnforcementStatus {
  SUGGESTED = "suggested",
  AUTO_STAGED = "auto_staged",
  REJECTED = "rejected",
  STAGED = "staged",
}

export enum SupportedMaterializedViews {
  MV_ALERTS_SURFACED_BY_HOUR = "mv_alerts_surfaced_by_hour",
  MV_ALERTS_SURFACED_BY_DAY = "mv_alerts_surfaced_by_day",
  MV_ALERTS_VERIFIED = "mv_alerts_verified",
  MV_ALERTS_TIMES_TO_ACTIONED = "mv_alerts_times_to_actioned",
  MV_EMAIL_ALERTS_TIMES_TO_ACTIONED = "mv_email_alerts_times_to_actioned",
  MV_DARK_WEB_ALERTS_SURFACED = "mv_dark_web_alerts_surfaced",
  MV_DARK_WEB_ALERTS_SURFACED_BY_HOUR = "mv_dark_web_alerts_surfaced_by_hour",
}

export enum IOCType {
  IP_ADDRESS = "ip_address",
  SITE_TITLE = "site_title",
  GTAG = "gtag",
  FACEBOOK_TRACKING_PIXEL = "facebook_tracking_pixel",
  URL = "url",
  EMAIL = "email",
  PHONE_NUMBER = "phone_number",
  QR_CODE = "qr_code",
  FILE = "file",
  TWITTER_AUTHOR_ID = "twitter_author_id",
  TWITTER_AUTHOR_USERNAME = "twitter_author_username",
  FACEBOOK_AUTHOR_ID = "facebook_author_id",
  FACEBOOK_GROUP_ID = "facebook_group_id",
  REFERENCED_WHATSAPP_NUMBER = "referenced_whatsapp_number",
}

export enum IOCStatus {
  VERIFIED = "verified",
  UNVERIFIED = "unverified",
  BENIGN = "benign",
}

export const IOCStatusLabels: { [key in IOCStatus]?: string } = {
  [IOCStatus.VERIFIED]: "Malicious",
  [IOCStatus.UNVERIFIED]: "Unverified",
  [IOCStatus.BENIGN]: "No Threat Detected",
};

export enum EmailSentimentAnalysisVerdict {
  LOW_CONFIDENCE = "low_confidence",
  MEDIUM_CONFIDENCE = "medium_confidence",
  HIGH_CONFIDENCE = "high_confidence",
}

export enum DetectionConfigType {
  SOURCING_QUERY = "sourcing_query",
  DETECTION_ASSET = "detection_asset",
  DETECTION_RULE = "detection_rule",
}

export enum SocialMediaContentType {
  PROFILE = "profile",
  POST = "post",
  PAGE = "page",
  GROUP = "group",
  VIDEO = "video",
  GROUP_CHAT = "group_chat",
  PHOTO = "photo",
  CHANNEL = "channel",
}

export enum AlertHashingMethod {
  SSDEEP = "ssdeep",
}

export enum AlertResourceType {
  WEBSITE_HTML = "website_html",
}

export enum StatType {
  ALERTS_VERIFIED_TOP_REGISTRARS = "alerts_verified_top_registrars",
  ALERTS_VERIFIED_TOP_WEB_HOSTS = "alerts_verified_top_web_hosts",
  ALERTS_VERIFIED_TOP_COUNTRY_CODES = "alerts_verified_top_country_codes",
  ALERTS_VERIFIED_TOP_PLATFORMS = "alerts_verified_top_platforms",
  ALERTS_VERIFIED_TOTAL_CREATED = "alerts_verified_total_created",
  ALERTS_SURFACED_TOTAL_CREATED = "alerts_surfaced_total_created",
  ALERTS_SURFACED_BREAKDOWN_BY_TIME = "alerts_surfaced_breakdown_by_time",
  ALERTS_MEDIAN_RESOLUTION_TIME = "alerts_median_resolution_time",
  ALERTS_MEDIAN_MITIGATION_TIME = "alerts_median_mitigation_time",
  ALERTS_MEDIAN_RESOLUTION_BREAKDOWN_BY_TIME = "alerts_median_resolution_breakdown_by_time",
  ALERTS_MEDIAN_MITIGATION_BREAKDOWN_BY_TIME = "alerts_median_mitigation_breakdown_by_time",
  ALERTS_RESOLVED_TOTAL_CREATED = "alerts_resolved_total_created",
  ALERTS_MEDIAN_RESOLUTION_BREAKDOWN_BY_PLATFORM = "alerts_median_resolution_breakdown_by_platform",
  ALERTS_RESOLVED_TOP_PLATFORMS = "alerts_resolved_top_platforms",
  ALERTS_SURFACED_TOP_PRODUCTS = "alerts_surfaced_top_products",
  ALERTS_RESOLVED_TOP_PRODUCTS = "alerts_resolved_top_products",
  DARK_WEB_ALERTS_SURFACED_TOTAL_CREATED = "dark_web_alerts_surfaced_total_created",
  DARK_WEB_ALERTS_SURFACED_BREAKDOWN_BY_TIME = "dark_web_alerts_surfaced_breakdown_by_time",
  DARK_WEB_ALERTS_SURFACED_TOP_NETWORKS = "dark_web_alerts_surfaced_top_networks",
}

export enum JiraIssueStatusDescription {
  PLATFORM_REPLY = "platform_reply",
  STALE_REQUEST = "stale_request",
  ANALYST_REPLY = "analyst_reply",
  RETRACTION_SENT = "retraction_sent",
  INFO_REQUESTED = "info_requested",
  RE_REPORT_NEEDED = "re_report_needed",
  REROUTED = "rerouted",
}

export const JiraIssueStatusDescriptionLabels: { [key in JiraIssueStatusDescription]?: string } = {
  [JiraIssueStatusDescription.PLATFORM_REPLY]: "Platform Replies",
  [JiraIssueStatusDescription.STALE_REQUEST]: "Stale Requests",
  [JiraIssueStatusDescription.ANALYST_REPLY]: "Analyst Replies",
  [JiraIssueStatusDescription.RETRACTION_SENT]: "Retractions",
  [JiraIssueStatusDescription.INFO_REQUESTED]: "info_requested",
  [JiraIssueStatusDescription.RE_REPORT_NEEDED]: "re_report_needed",
  [JiraIssueStatusDescription.REROUTED]: "rerouted",
};

export enum FormFieldsOptions {
  CUSTOMER_LEGAL_NAME = "customer_legal_name",
  CUSTOMER_ENFORCEMENT_EMAIL = "customer_enforcement_email",
  ORIGINAL_SITE = "original_site",
  DOPPEL_MAILING_ADDRESS = "doppel_mailing_address",
  REPORTING_AGENT_NAME = "reporting_agent_name",
  TRADEMARK_HOLDER_NAME = "trademark_holder_name",
  TRADEMARK_HOLDER_ADDRESS = "trademark_holder_address",
  TRADEMARK_REGISTRATION_NUMBER = "trademark_registration_number",
  TRADEMARK_REGISTRATION_OFFICE = "trademark_registration_office",
  TRADEMARK_MARK = "trademark_mark",
  TRADEMARK_HOLDER_COUNTRY_CODE = "trademark_holder_country_code",
  TRADEMARK_HOLDER_COMPANY_NAME = "trademark_holder_company_name",
  TRADEMARK_GOODS_OR_SERVICES_CLASS = "trademark_goods_or_services_class",
  TRADEMARK_HOLDER_WEBSITE = "trademark_holder_website",
  TRADEMARK_REGISTRATION_CERTIFICATE_URL = "trademark_registration_certificate_url",
  FLAGGED_URL = "flagged_url",
  UNSANITIZED_URL = "unsanitized_url",
  MESSAGE_TEMPLATE = "message_template",
}

export enum SubmissionSource {
  MANUAL = "manual",
  SCRIPT = "script",
  API = "api",
  GIT_PR = "git_pr",
  AUTOMATED_FORM = "automated_form",
  AUTOMATED_EMAIL = "automated_email",
}

export enum RetrievalOptions {
  ENVIRONMENT_VARIABLE = "environment_variable",
  DB_ACCESS = "db_access",
}

export enum FormFieldsDBTables {
  SPOOFING_REPORTS = "spoofing_reports",
  TRADEMARKS = "trademarks",
  ENFORCEMENT_TEMPLATES = "enforcement_templates",
  DESIGNATED_ASSETS = "designated_assets",
}

export enum SourcedUrlStatus {
  PENDING = "pending",
  PROCESSED = "processed",
  DEDUPLICATED = "deduplicated",
  FILTERED = "filtered",
  CRASHED = "crashed",
  NO_OPED = "no_oped",
}

export enum DnsDigStatus {
  NOERROR = "NOERROR",
  NXDOMAIN = "NXDOMAIN",
  TIMEOUT = "TIMEOUT",
  NO_NAMESERVERS = "NO NAMESERVERS",
  NOANSWER = "NOANSWER",
  UNKNOWN = "UNKNOWN",
}

export enum RuleFieldType {
  TEXT = "text",
  NUMERIC = "numeric",
  SELECT = "select",
  NO_INPUT = "none",
}

export enum AlertQueueProductTypes {
  DOMAINS = "domains",
  SOCIAL_MEDIA = "social_media",
  PAID_ADS = "paid_ads",
}

export enum AutoSourcedSocialMediaPlatforms {
  TWITTER = "twitter",
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  YOUTUBE = "youtube",
  TIKTOK = "tiktok",
}

export enum UrlAuditStatus {
  NOT_SOURCED = "not_sourced",
  SOURCED_BUT_NO_ALERT = "sourced_but_no_alert",
  SOURCED_AND_ALERT_CREATED = "sourced_and_alert_created",
}

export enum AlertAgeStatus {
  NOT_AGED = "Non-aged Alerts",
  AGED = "Aged Alerts",
}

export enum DarkWebLeakContents {
  USER = "user",
  PASSWORD = "password",
  CREDENTIAL_URL = "credential_url",
}

export enum ThreatLinkType {
  HYPERLINK = "hyperlink",
  TWITTER_REPOST = "twitter_repost",
  TWITTER_REPLY = "twitter_reply",
  FACEBOOK_AUTHOR = "facebook_author",
  FACEBOOK_SHARE = "facebook_share",
  FACEBOOK_COMMENT = "facebook_comment",
  TWITTER_AUTHOR = "twitter_author",
  YOUTUBE_POSTER = "youtube_poster",
  REDIRECT = "redirect",
  DOMAIN_REGISTRATION = "domain_registration",
  DOMAIN_REGISTRATION_CONTACT = "domain_registration_contact",
  FACEBOOK_POST_BOOSTED = "facebook_post_boosted",
  AD_DESTINATION = "ad_destination",
  META_ADVERTISER_PROFILE = "meta_advertiser_profile",
  AD_AUTHOR = "ad_author",
  REFERENCED_PHONE_NUMBER = "referenced_phone_number",
  REFERENCED_EMAIL_ADDRESS = "referenced_email_address",
  REFERENCED_SOCIAL_MEDIA_ACCOUNT = "referenced_social_media_account",
  REFERENCED_SOCIAL_MEDIA_GROUP = "referenced_social_media_group",
  REFERENCED_SOCIAL_MEDIA_POST = "referenced_social_media_post",
  TIKTOK_FOLLOW = "tiktok_follow",
  TWITTER_FOLLOW = "twitter_follow",
  FACEBOOK_FRIEND = "facebook_friend",
  FACEBOOK_GROUP_POST = "facebook_group_post",
  FACEBOOK_GROUP_MEMBER = "facebook_group_member",
  FACEBOOK_GROUP_ADMIN = "facebook_group_admin",
  FACEBOOK_ACCOUNT_PHONE = "facebook_account_phone",
  FACEBOOK_ACCOUNT_EMAIL = "facebook_account_email",
  TELEGRAM_AUTHOR = "telegram_author",
}

export enum BooleanFilterOptions {
  TRUE = "true",
  FALSE = "false",
}

export enum EmailCorrespondenceType {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

export enum UrlAuditStatusSourcing {
  NOT_SOURCED = "not_sourced",
  SOURCED = "sourced",
  SOURCED_LATE = "sourced_late",
}

export enum UrlAuditStatusAlertCreated {
  NOT_CREATED = "not_created",
  CREATED = "created",
}

export enum PasswordComplexity {
  REQUIRES_UPPERCASE_LETTER = "requires_uppercase_letter",
  REQUIRES_NUMBER = "requires_number",
  REQUIRES_SPECIAL_CHARACTERS = "requires_special_characters",
  PASSWORD_LENGTH = "password_length",
  CUSTOM_REGEX = "custom_regex",
}

export enum PasswordComplexityStaticLookaheads {
  REQUIRES_UPPERCASE_LETTER = "(?=.*[A-Z])",
  REQUIRES_NUMBER = "(?=.*\d)",
  REQUIRES_SPECIAL_CHARACTERS = "(?=.*[^A-Za-z0-9])",
}

export enum ESCCaller {
  REVIVAL_MONITORING = "revival_monitoring",
  DELIST_MONITORING = "delist_monitoring",
  DOMAIN_CANDIDATE_PROCESSING = "domain_candidate_processing",
  ALERT_QUEUE_ASSIGNMENT = "alert_queue_assignment",
  UNKNOWN = "unknown",
}

export enum ESCPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export enum ESCClassification {
  DOWN = "down",
  PARKED = "parked",
  ACTIVE = "active",
  UNABLE_TO_CLASSIFY = "unable_to_classify",
}

export enum ESCClassificationReason {
  DIG_NXDOMAIN = "dig_nxdomain",
  DNS_NXDOMAIN = "dns_nxdomain",
  DNS_RECORDS_NOT_FOUND = "dns_records_not_found",
  DNS_SUSPENDED_KEYWORD_FOUND = "dns_suspended_keyword_found",
  DNS_NO_NAME_SERVERS_FOUND = "dns_no_name_servers_found",
  WHOIS_DOWN_EPP_STATUS_FOUND = "whois_down_epp_status_found",
  DNS_PARKING_NAMESERVER_KEYWORD_FOUND = "dns_parking_nameserver_keyword_found",
  DNS_PARKING_IP_ADDRESS_FOUND = "dns_parking_ip_address_found",
  HOSTNAME_RESOLUTION_FAILED = "hostname_resolution_failed",
  SUSPENDED_KEYWORD_IN_DOMAIN = "suspended_keyword_in_domain",
  HTTP_CODE = "http_code",
  MATCHED_GENERIC_KEYWORD_PHRASE = "matched_generic_keyword_phrase",
  MATCHED_SPECIFIC_KEYWORD_PHRASE = "matched_specific_keyword_phrase",
  HASHING_SIMILARITY = "hashing_similarity",
  LLM = "llm",
}

export enum DetectionRuleType {
  ALERT_CREATION = "alert_creation",
  ALERT_UPDATE = "alert_update",
}

export enum AlertCreationRuleDecision {
  CREATE_ALERT = "create_alert",
  SKIP_ALERT_CREATION = "skip_alert_creation",
  NO_MATCH = "no_match",
}

export enum ESCClassificationEvidenceType {
  WHOIS_STATUS = "whois_status",
  MATCHING_EPP_STATUS = "matching_epp_status",
  DIG_STATUS = "dig_status",
  DNS_RECORD_TYPES_CHECKED = "dns_record_types_checked",
  MATCHING_SUSPENDED_KEYWORD = "matching_suspended_keyword",
  MATCHING_DNS_RECORD = "matching_record",
  MATCHING_DNS_NAMESERVER = "matching_dns_nameserver",
  MATCHING_DNS_NAMESERVER_KEYWORD = "matching_dns_nameserver_keyword",
  MATCHING_DNS_IP_ADDRESS = "matching_dns_ip_address",
  HOSTNAME_CHECKED = "hostname_checked",
  MATCHING_SPECIFIC_KEYWORD_PHRASE = "matching_specific_keyword_phrase",
  MATCHING_GENERIC_KEYWORD_PHRASE = "matching_generic_keyword_phrase",
  HASH_SIMILARITY_SCORE = "hash_similarity_score",
  HTTP_STATUS_CODE = "http_status_code",
  LLM_JUSTIFICATION = "llm_justification",
}

export enum AlertTableColumn {
  STATE = "state",
  SEVERITY = "severity",
  SCORE = "score",
  BRAND = "brand",
  ORGANIZATION = "organization",
  URL = "url",
  PHONE_NUMBER = "phone_number",
  PROVIDER = "provider",
  DATE_REPORTED = "date_reported",
  LAST_RESOLVED_AT = "last_resolved_at",
  PRODUCT = "product",
  PLATFORM_SUBTYPE = "platform_subtype",
  ENFORCEMENTS = "enforcements",
  FOLLOWERS = "followers",
  COUNTRY = "country",
  NAMESERVERS = "nameservers",
  MX = "mx",
  TELCO_COUNTRY = "telco_country",
  SOURCE = "source",
  ESTIMATED_VALUE = "estimated_value",
  CRAWLED_AT = "crawled_at",
  USER = "user",
  PASSWORD = "password",
  CREDENTIAL_URL = "credential_url",
  HIGHLIGHT = "highlight",
  TITLE = "title",
  BIN = "bin",
  CCN = "ccn",
  EXPIRATION_DATE = "expiration_date",
  CARDHOLDER_NAME = "cardholder_name",
  CARDHOLDER_ADDRESS = "cardholder_address",
  NETWORK = "network",
  SUBJECT = "subject",
  SUBMITTED_BY = "submitted_by",
  ALERT_CREATED = "alert_created",
  ID = "id",
  PREVIEW = "preview",
  NOTES = "notes",
  TAGS = "tags",
  LAST_ACTIVITY = "last_activity",
  LAST_ACTIONED_AT = "last_actioned_at",
  ASSIGNEE = "assignee",
  EXTERNAL_ASSIGNEE = "external_assignee",
  LEAK_NAME = "leak_name",
  PRODUCT_ENABLEMENT_STATUS = "product_enablement_status",
}

export const AlertTableColumnLabels: { [key in AlertTableColumn]?: string } = {
  [AlertTableColumn.STATE]: "State",
  [AlertTableColumn.SEVERITY]: "Severity",
  [AlertTableColumn.SCORE]: "Score",
  [AlertTableColumn.BRAND]: "Brand",
  [AlertTableColumn.ORGANIZATION]: "Org",
  [AlertTableColumn.URL]: "URL",
  [AlertTableColumn.PHONE_NUMBER]: "Phone Number",
  [AlertTableColumn.PROVIDER]: "Provider",
  [AlertTableColumn.DATE_REPORTED]: "Date Reported",
  [AlertTableColumn.LAST_RESOLVED_AT]: "Date Taken Down",
  [AlertTableColumn.PRODUCT]: "product",
  [AlertTableColumn.PLATFORM_SUBTYPE]: "Type",
  [AlertTableColumn.ENFORCEMENTS]: "Mitigation",
  [AlertTableColumn.FOLLOWERS]: "Followers",
  [AlertTableColumn.COUNTRY]: "CN.",
  [AlertTableColumn.NAMESERVERS]: "Nameservers",
  [AlertTableColumn.MX]: "MX",
  [AlertTableColumn.TELCO_COUNTRY]: "Country",
  [AlertTableColumn.SOURCE]: "Source",
  [AlertTableColumn.ESTIMATED_VALUE]: "Estimated Value",
  [AlertTableColumn.CRAWLED_AT]: "Crawled At",
  [AlertTableColumn.USER]: "User",
  [AlertTableColumn.PASSWORD]: "Password",
  [AlertTableColumn.CREDENTIAL_URL]: "Credential Url",
  [AlertTableColumn.HIGHLIGHT]: "Highlight",
  [AlertTableColumn.TITLE]: "Title",
  [AlertTableColumn.BIN]: "BIN",
  [AlertTableColumn.CCN]: "CCN",
  [AlertTableColumn.EXPIRATION_DATE]: "Expiration Date",
  [AlertTableColumn.CARDHOLDER_NAME]: "Cardholder Name",
  [AlertTableColumn.CARDHOLDER_ADDRESS]: "Cardholder Address",
  [AlertTableColumn.NETWORK]: "Network",
  [AlertTableColumn.SUBJECT]: "Subject",
  [AlertTableColumn.SUBMITTED_BY]: "Submitted By",
  [AlertTableColumn.ALERT_CREATED]: "Alert Created",
  [AlertTableColumn.ID]: "Id",
  [AlertTableColumn.PREVIEW]: "Preview",
  [AlertTableColumn.NOTES]: "Notes",
  [AlertTableColumn.TAGS]: "Tags",
  [AlertTableColumn.LAST_ACTIVITY]: "Last Activity",
  [AlertTableColumn.LAST_ACTIONED_AT]: "Last Actioned At",
  [AlertTableColumn.ASSIGNEE]: "Internal Assignee",
  [AlertTableColumn.EXTERNAL_ASSIGNEE]: "Assignee",
  [AlertTableColumn.LEAK_NAME]: "Leak Name",
  [AlertTableColumn.PRODUCT_ENABLEMENT_STATUS]: "Product Status",
};

export enum Suspiciousness {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  NA = "NA",
  ERROR = "ERROR",
}

export enum DetectionConfigCreationMethod {
  AUTO = "AUTO",
  LLM = "LLM",
}

export enum LLMServiceExperimentResult {
  TP = "TRUE_POSITIVE",
  FP = "FALSE_POSITIVE",
  TN = "TRUE_NEGATIVE",
  FN = "FALSE_NEGATIVE",
}

export enum LLMExperimentEvaluatorRunMode {
  SINGLE_SPECIFIED_MODEL = "single_specified_model",
  FULL_LLM_SERVICE_PIPELINE = "full_llm_service_pipeline",
}

export enum SafelistStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export enum DesignatedTakedownAssetStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export enum IOCFields {
  STATUS = "status",
}

export enum Role {
  CUSTOMER_ADMIN = "customer_admin",
  EMPLOYEE = "employee",
  CUSTOMER_SUPER_ADMIN = "customer_super_admin",
  CUSTOMER_USER = "customer_user",
  CUSTOMER_VIEWER = "customer_viewer",
}

export const RoleLabels: { [key in Role]?: string } = {
  [Role.CUSTOMER_ADMIN]: "Admin",
  [Role.EMPLOYEE]: "Employee",
  [Role.CUSTOMER_SUPER_ADMIN]: "Super Admin",
  [Role.CUSTOMER_USER]: "User",
  [Role.CUSTOMER_VIEWER]: "Viewer",
};

export enum Permission {
  USER_CREATE = "user.create",
  USER_UPDATE = "user.update",
  USER_DELETE = "user.delete",
  ALERT_COMMENT_CREATE = "alert.comment.create",
  ALERT_QUEUE_UPDATE = "alert.queue.update",
  ALERT_READ = "alert.read",
  ALERT_CREATE = "alert.create",
  ALERT_UPDATE = "alert.update",
  ALERT_CSV_READ = "alert.csv.read",
  TAG_CREATE = "tag.create",
  TAG_UPDATE = "tag.update",
  TAG_DELETE = "tag.delete",
  PROTECTED_ASSET_CREATE = "protected_asset.create",
  PROTECTED_ASSET_UPDATE = "protected_asset.update",
  PROTECTED_ASSET_DELETE = "protected_asset.delete",
  PROTECTED_ASSET_CSV_READ = "protected_asset.csv.read",
  PII_READ = "pii.read",
  PII_CREATE = "pii.create",
  PII_EDIT = "pii.edit",
  PII_DELETE = "pii.delete",
}

export enum DetectionConfigApprovalStatus {
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export enum ScanResultCategory {
  PHISHING = "phishing",
}

export enum HeadlessLoginTokenProviders {
  RIPPLING = "rippling",
}

export enum OnboardingStatus {
  PENDING = "pending",
  ACTIVE = "active",
  DEACTIVATED = "deactivated",
}

export const OnboardingStatusLabels: { [key in OnboardingStatus]?: string } = {
  [OnboardingStatus.PENDING]: "Pending",
  [OnboardingStatus.ACTIVE]: "Active",
  [OnboardingStatus.DEACTIVATED]: "Deactivated",
};

export enum JiraIssueStatus {
  TO_DO = "To Do",
  IN_REVIEW = "In Review",
  IN_PROGRESS = "In Progress",
  DONE = "Done",
  REJECTED = "Rejected",
  CANCELED = "Canceled",
  ARCHIVED = "Archived",
}

export enum DesignatedTakedownAssetType {
  ORG_DEFAULT_ASSET = "org_default_asset",
  BRAND_ASSET = "brand_asset",
}

export enum AlertLimitExceededError {
  MESSAGE = "Cannot assign more than 100 alerts to a single ops analyst",
  TITLE = "Assignment Limit Exceeded",
}

export enum ThreatLinkCategory {
  CREATOR = "creator",
  REFERENCE = "reference",
  REPLY = "reply",
  EMBED = "embed",
}

export enum AlertMovementReasons {
  UNRELATED_TO_ENTITY = "unrelated_to_entity",
  SIMILAR_OTHER_BRAND = "similar_other_brand",
  CUSTOMER_OWNED_SITE = "customer_owned_site",
  CUSTOMER_AFFILIATED_SITE = "customer_affiliated_site",
  RUBRIC_POLICY = "rubric_policy",
  FUTURE_RISK_SITE = "future_risk_site",
  DUPLICATE = "duplicate",
  POTENTIAL_CUSTOMER_OWNED_SITE = "potential_customer_owned_site",
  POTENTIAL_CUSTOMER_AFFILIATED_SITE = "potential_customer_affiliated_site",
  CUSTOMER_REQUEST = "customer_request",
  DOWN_BEFORE_REVIEW = "down_before_review",
  REVIVED = "revived",
  OTHER = "other",
}

export const AlertMovementReasonsLabels: { [key in AlertMovementReasons]?: string } = {
  [AlertMovementReasons.UNRELATED_TO_ENTITY]: "Unrelated to the org/brand",
  [AlertMovementReasons.SIMILAR_OTHER_BRAND]: "Similar name, different (legit) brand",
  [AlertMovementReasons.CUSTOMER_OWNED_SITE]: "customer_owned_site",
  [AlertMovementReasons.CUSTOMER_AFFILIATED_SITE]: "Customer-affiliated or vendor site",
  [AlertMovementReasons.RUBRIC_POLICY]: "rubric_policy",
  [AlertMovementReasons.FUTURE_RISK_SITE]: "Currently inactive, potential future risk",
  [AlertMovementReasons.DUPLICATE]: "Duplicate with another actioned alert",
  [AlertMovementReasons.POTENTIAL_CUSTOMER_OWNED_SITE]: "potential_customer_owned_site",
  [AlertMovementReasons.POTENTIAL_CUSTOMER_AFFILIATED_SITE]: "potential_customer_affiliated_site",
  [AlertMovementReasons.CUSTOMER_REQUEST]: "customer_request",
  [AlertMovementReasons.DOWN_BEFORE_REVIEW]: "down_before_review",
  [AlertMovementReasons.REVIVED]: "Revived",
  [AlertMovementReasons.OTHER]: "other",
};

export enum OrganizationSegment {
  Strategic = "Strategic",
  Enterprise = "Enterprise",
  MidMarket = "MidMarket",
}

export enum SimCampaignStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
}

export const SimCampaignStatusLabels: { [key in SimCampaignStatus]?: string } = {
  [SimCampaignStatus.PENDING]: "Pending",
  [SimCampaignStatus.IN_PROGRESS]: "In Progress",
  [SimCampaignStatus.FINISHED]: "Finished",
};

export enum SimEmailStatus {
  PENDING = "pending",
  SENT = "sent",
}

export const SimEmailStatusLabels: { [key in SimEmailStatus]?: string } = {
  [SimEmailStatus.PENDING]: "Pending",
  [SimEmailStatus.SENT]: "Sent",
};

export enum EntityType {
  ORGANIZATION_BRAND = "organization_brand",
  PERSONAL_BRAND = "personal_brand",
}

export const EntityTypeLabels: { [key in EntityType]?: string } = {
  [EntityType.ORGANIZATION_BRAND]: "Organization Brand",
  [EntityType.PERSONAL_BRAND]: "Employee Brand",
};

export enum ClickTrackingEventTypes {
  ANALYTICS_SEND_TO_CUSTOMERS = "analytics_send_to_customers",
  ANALYTICS_DOWNLOAD_REPORT = "analytics_download_report",
  ANALYTICS_ALERTS_CREATED_GRAPH_DRILLDOWN = "analytics_alerts_created_drilldown",
  ANALYTICS_ALERTS_CREATED_NUMBER_WIDGET_DRILLDOWN = "analytics_alerts_created_number_widget_drilldown",
  ANALYTICS_ALERTS_RESOLVED_NUMBER_WIDGET_DRILLDOWN = "analytics_alerts_resolved_number_widget_drilldown",
  ALERT_VERSIONING_DROPDOWN_SELECTION = "alert_versioning_dropdown_select",
  THREAT_GRAPH_DETAIL_VIEW = "threat_graph_detail_view",
}

export enum SimCampaignActions {
  EMAIL_OPENED = "email_opened",
  LINK_CLICKED = "link_clicked",
  FORM_SUBMITTED = "form_submitted",
}

export const SimCampaignActionsLabels: { [key in SimCampaignActions]?: string } = {
  [SimCampaignActions.EMAIL_OPENED]: "Email Opened",
  [SimCampaignActions.LINK_CLICKED]: "Link Clicked",
  [SimCampaignActions.FORM_SUBMITTED]: "Form Submitted",
};

export enum ElasticsearchOperator {
  EQUALS = "equals",
  CONTAINS = "contains",
  IN = "in",
  WILDCARD = "wildcard",
  REGEX = "regex",
  GT = "gt",
  LT = "lt",
  GTE = "gte",
  LTE = "lte",
}

export enum ElasticsearchLogicalOperator {
  AND = "and",
  OR = "or",
  NOT = "not",
}

export enum ProductEnablementStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  TRIAL = "trial",
}

export enum EnforcementPlatformComplianceStatus {
  SLOW_RESPONSE = "slow_response",
  MALICIOUS = "malicious",
  DEFAULT = "default",
  NON_COMPLIANT = "non_compliant",
}

export enum TrademarkType {
  LOGO = "logo",
  WORD = "word",
  COMBINATION = "combination",
}

export enum BrandSimilarityLabels {
  TYPOSQUAT = "typosquat",
  BRAND_LOGO_INFRINGEMENT = "brand_logo_infringement",
  CONTENT_INFRINGEMENT = "content_infringement",
  NOT_SIMILAR_TO_BRAND = "not_similar_to_brand",
  OTHER = "other",
}

export enum DomainMaliciousnessLabels {
  CREDENTIAL_THEFT = "credential_theft",
  NOT_MALICIOUS = "not_malicious",
  OTHER = "other",
}

export enum SocialMediaContentViolationLabels {
  HATEFUL_CONDUCT = "hateful_conduct",
  FRAUD_SCAMS_AND_DECEPTIVE_PRACTICES = "fraud_scams_and_deceptive_practices",
  SPAM = "spam",
  VIOLENCE_INCITEMENT = "violence_incitement",
  COORDINATING_HARM_AND_PROMOTING_CRIME = "coordinating_harm_and_promoting_crime",
  NO_CONTENT_VIOLATION = "no_content_violation",
  OTHER = "other",
}

export enum SupportedElasticsearchIndices {
  SPOOFING_REPORTS = "spoofing-reports",
}

export enum CloudLogSeverity {
  ERROR = "error",
  WARN = "warn",
  INFO = "info",
}

export enum Platform {
  COINBASE = "coinbase",
  BINANCE = "binance",
  OPENSEA = "opensea",
  MINTABLE = "mintable",
  MAGICEDEN = "magiceden",
  OKX = "okx",
  RARIBLE = "rarible",
  CRYPTO_OTHER = "crypto_other",
  SHELLIX = "shellix",
  DARKMARKET_OTHER = "darkmarket_other",
  DARKWEB = "darkweb",
  CRED_LEAKS = "cred_leaks",
  CREDIT_CARD_LEAKS = "credit_card_leaks",
  API_LEAKS = "api_leaks",
  DOMAINS = "domains",
  ROOT_DOMAIN = "root_domain",
  GITBOOK = "gitbook",
  WEBFLOW = "webflow",
  SHOPEE = "shopee",
  BEST_ALIEXPRESS = "best_aliexpress",
  WISH = "wish",
  WILDBERRIES = "wildberries",
  ALIBABA = "alibaba",
  ROBLOX = "roblox",
  AMAZON = "amazon",
  WALMART = "walmart",
  CRAIGSLIST = "craigslist",
  ETSY = "etsy",
  EBAY = "ebay",
  LAZADA = "lazada",
  Z2U = "z2u",
  TOKOPEDIA = "tokopedia",
  FACEBOOK_MARKETPLACE = "facebook_marketplace",
  ECOMMERCE_OTHER = "ecommerce_other",
  EMAIL = "email",
  APPLE_APP_STORE = "apple_app_store",
  APKGK = "apkgk",
  UPTODOWN = "uptodown",
  STEPRIMO = "steprimo",
  APPBRAIN = "appbrain",
  GOOGLE_PLAY_STORE = "google_play_store",
  APTOIDE = "aptoide",
  NINEAPPS = "9apps",
  APKCOMBO = "apkcombo",
  APKPURE = "apkpure",
  CAFEBAZAAR = "cafebazaar",
  GAMELOOP = "gameloop",
  HAPPYMOD = "happymod",
  APKHOUSE = "apkhouse",
  IODROID = "iodroid",
  MALAVIDA = "malavida",
  APKMODY = "apkmody",
  APK4K = "apk4k",
  APKFREE = "apkfree",
  APKDOWNLOAD = "apkdownload",
  APKMONK = "apkmonk",
  APKSOS = "apksos",
  APKSUPPORT = "apksupport",
  APKTOY = "apktoy",
  FILEHIPPO = "filehippo",
  _99IMAGES = "99images",
  APKDOG = "apkdog",
  APKBOG = "apkbog",
  APKLUST = "apklust",
  APPSONWINDOWS = "appsonwindows",
  NEDGET = "nedget",
  SOFTONIC = "softonic",
  SOFTSTON = "softston",
  GETJAR = "getjar",
  APKMIRROR = "apkmirror",
  OPERA = "opera",
  FILEHORSE = "filehorse",
  UOLDOWN = "uoldown",
  APKDOWNLOADHUNT = "apkdownloadhunt",
  APKLOO = "apkloo",
  APKNITE = "apknite",
  APPVN = "appvn",
  SMARTLOADS = "smartloads",
  LUCKYMODAPK = "luckymodapk",
  APKSHUB = "apkshub",
  CAPTAINDROID = "captaindroid",
  IPA4FUN = "ipa4fun",
  AAPKS = "aapks",
  APKMODULE = "apkmodule",
  APK20 = "apk20",
  APKFOLLOW = "apkfollow",
  APKSOUL = "apksoul",
  ANDROIDFREEWARE = "androidfreeware",
  PCMACSTORE = "pcmacstore",
  ANDROIDBLUE = "androidblue",
  MODDROID = "moddroid",
  APKDOM = "apkdom",
  WEBCATALOG = "webcatalog",
  ANDROIDAPPSAPK = "androidappsapk",
  SOFT112 = "soft112",
  A2ZAPK = "a2zapk",
  BIGNOX = "bignox",
  NAPKFORPC = "napkforpc",
  APKVISIT = "apkvisit",
  APKBE = "apkbe",
  PHONEKY = "phoneky",
  APK3 = "apk3",
  APPONIC = "apponic",
  ANDRIODAPK = "andriodapk",
  MODPURE = "modpure",
  JOJOY = "jojoy",
  APKSTREAMZ = "apkstreamz",
  APK4FUN = "apk4fun",
  APKBIND = "apkbind",
  APKVISION = "apkvision",
  ANDROIDOUT = "androidout",
  DFAST = "dfast",
  MODCOMBO = "modcombo",
  MEMUPLAY = "memuplay",
  VEAPPS = "veapps",
  APKCAFE = "apkcafe",
  APKSHKI = "apkshki",
  KINGMODAPK = "kingmodapk",
  APKGOLD = "apkgold",
  ANDROIDGOZAR = "androidgozar",
  CRX4CHROME = "crx4chrome",
  APKAMP = "apkamp",
  APKTUME = "apktume",
  APPLATEST = "applatest",
  APKEASY = "apkeasy",
  APKNITRO = "apknitro",
  BAIXEFACIL = "baixefacil",
  ANDROIDLISTA = "androidlista",
  MATJARAPK = "matjarapk",
  GOZLA = "gozla",
  APKWATCH = "apkwatch",
  APKSSOFTWARE = "apkssoftware",
  KERNAPK = "kernapk",
  APKTIP = "apktip",
  APKUNDUH = "apkunduh",
  TRAPK = "trapk",
  MODAPKDOWN = "modapkdown",
  MODAPKCLOUD = "modapkcloud",
  LDPLAYER = "ldplayer",
  ANDROIDBLIP = "androidblip",
  FREEAPK = "freeapk",
  MOBILE_APPS_OTHER = "mobile_apps_other",
  GOOGLE_ADS = "google_ads",
  FACEBOOK_ADS = "facebook_ads",
  BING_ADS = "bing_ads",
  PAID_ADS_OTHER = "paid_ads_other",
  TWITTER = "twitter",
  TIKTOK = "tiktok",
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  YOUTUBE = "youtube",
  TELEGRAM = "telegram",
  LINKEDIN = "linkedin",
  REDDIT = "reddit",
  GITHUB = "github",
  PINTEREST = "pinterest",
  DISCORD = "discord",
  WHATSAPP = "whatsapp",
  TRUTH_SOCIAL = "truth_social",
  FACEBOOK_PROFILE = "facebook",
  SPOTIFY = "spotify",
  TWITCH = "twitch",
  THREADS = "threads",
  SNAPCHAT = "snapchat",
  WEIBO = "weibo",
  MEDIUM = "medium",
  LINKTREE = "linktree",
  TUMBLR = "tumblr",
  SOCIAL_MEDIA_OTHER = "social_media_other",
  TELCO = "telco",
  SUSPICIOUS_EMAILS = "suspicious_emails",
  CLOUDFLARE_PAGES = "cloudflare_pages",
  DEXSCREENER = "dexscreener",
  UPBIT = "upbit",
  KRAKEN = "kraken",
  KUCOIN = "kucoin",
  MEXC = "mexc",
  TRADINGVIEW = "tradingview",
  CRYPTORANK = "cryptorank",
  BYBIT = "bybit",
  HTX = "htx",
  LIVECOINWATCH = "livecoinwatch",
  BITSCREENER = "bitscreener",
  BLUESKY = "bluesky",
  SUIVISION = "suivision",
  SUISCAN = "suiscan",
  SUIEXPLORER = "suiexplorer",
  KAKAO = "kakao",
  QUORA = "quora",
  NOTION = "notion",
  LINE = "line",
}

export enum PlatformSubtype {
  COINBASE = "coinbase",
  BINANCE = "binance",
  OPENSEA = "opensea",
  MINTABLE = "mintable",
  MAGICEDEN = "magiceden",
  OKX = "okx",
  RARIBLE = "rarible",
  CRYPTO_OTHER = "crypto_other",
  SHELLIX = "shellix",
  DARKMARKET_OTHER = "darkmarket_other",
  DARKWEB = "darkweb",
  CRED_LEAKS = "cred_leaks",
  CREDIT_CARD_LEAKS = "credit_card_leaks",
  API_LEAKS = "api_leaks",
  DOMAINS = "domains",
  ROOT_DOMAIN = "root_domain",
  GITBOOK = "gitbook",
  WEBFLOW = "webflow",
  SHOPEE = "shopee",
  BEST_ALIEXPRESS = "best_aliexpress",
  WISH = "wish",
  WILDBERRIES = "wildberries",
  ALIBABA = "alibaba",
  ROBLOX = "roblox",
  AMAZON = "amazon",
  WALMART = "walmart",
  CRAIGSLIST = "craigslist",
  ETSY = "etsy",
  EBAY = "ebay",
  LAZADA = "lazada",
  Z2U = "z2u",
  TOKOPEDIA = "tokopedia",
  FACEBOOK_MARKETPLACE = "facebook_marketplace",
  ECOMMERCE_OTHER = "ecommerce_other",
  EMAIL = "email",
  APPLE_APP_STORE = "apple_app_store",
  APKGK = "apkgk",
  UPTODOWN = "uptodown",
  STEPRIMO = "steprimo",
  APPBRAIN = "appbrain",
  GOOGLE_PLAY_STORE = "google_play_store",
  APTOIDE = "aptoide",
  NINEAPPS = "9apps",
  APKCOMBO = "apkcombo",
  APKPURE = "apkpure",
  CAFEBAZAAR = "cafebazaar",
  GAMELOOP = "gameloop",
  HAPPYMOD = "happymod",
  APKHOUSE = "apkhouse",
  IODROID = "iodroid",
  MALAVIDA = "malavida",
  APKMODY = "apkmody",
  APK4K = "apk4k",
  APKFREE = "apkfree",
  APKDOWNLOAD = "apkdownload",
  APKMONK = "apkmonk",
  APKSOS = "apksos",
  APKSUPPORT = "apksupport",
  APKTOY = "apktoy",
  FILEHIPPO = "filehippo",
  _99IMAGES = "99images",
  APKDOG = "apkdog",
  APKBOG = "apkbog",
  APKLUST = "apklust",
  APPSONWINDOWS = "appsonwindows",
  NEDGET = "nedget",
  SOFTONIC = "softonic",
  SOFTSTON = "softston",
  GETJAR = "getjar",
  APKMIRROR = "apkmirror",
  OPERA = "opera",
  FILEHORSE = "filehorse",
  UOLDOWN = "uoldown",
  APKDOWNLOADHUNT = "apkdownloadhunt",
  APKLOO = "apkloo",
  APKNITE = "apknite",
  APPVN = "appvn",
  SMARTLOADS = "smartloads",
  LUCKYMODAPK = "luckymodapk",
  APKSHUB = "apkshub",
  CAPTAINDROID = "captaindroid",
  IPA4FUN = "ipa4fun",
  AAPKS = "aapks",
  APKMODULE = "apkmodule",
  APK20 = "apk20",
  APKFOLLOW = "apkfollow",
  APKSOUL = "apksoul",
  ANDROIDFREEWARE = "androidfreeware",
  PCMACSTORE = "pcmacstore",
  ANDROIDBLUE = "androidblue",
  MODDROID = "moddroid",
  APKDOM = "apkdom",
  WEBCATALOG = "webcatalog",
  ANDROIDAPPSAPK = "androidappsapk",
  SOFT112 = "soft112",
  A2ZAPK = "a2zapk",
  BIGNOX = "bignox",
  NAPKFORPC = "napkforpc",
  APKVISIT = "apkvisit",
  APKBE = "apkbe",
  PHONEKY = "phoneky",
  APK3 = "apk3",
  APPONIC = "apponic",
  ANDRIODAPK = "andriodapk",
  MODPURE = "modpure",
  JOJOY = "jojoy",
  APKSTREAMZ = "apkstreamz",
  APK4FUN = "apk4fun",
  APKBIND = "apkbind",
  APKVISION = "apkvision",
  ANDROIDOUT = "androidout",
  DFAST = "dfast",
  MODCOMBO = "modcombo",
  MEMUPLAY = "memuplay",
  VEAPPS = "veapps",
  APKCAFE = "apkcafe",
  APKSHKI = "apkshki",
  KINGMODAPK = "kingmodapk",
  APKGOLD = "apkgold",
  ANDROIDGOZAR = "androidgozar",
  CRX4CHROME = "crx4chrome",
  APKAMP = "apkamp",
  APKTUME = "apkamp",
  APPLATEST = "applatest",
  APKEASY = "apkeasy",
  APKNITRO = "apknitro",
  BAIXEFACIL = "baixefacil",
  ANDROIDLISTA = "androidlista",
  MATJARAPK = "matjarapk",
  GOZLA = "gozla",
  APKWATCH = "apkwatch",
  APKSSOFTWARE = "apkssoftware",
  KERNAPK = "kernapk",
  APKTIP = "apktip",
  APKUNDUH = "apkunduh",
  TRAPK = "trapk",
  MODAPKDOWN = "modapkdown",
  MODAPKCLOUD = "modapkcloud",
  LDPLAYER = "ldplayer",
  ANDROIDBLIP = "androidblip",
  FREEAPK = "freeapk",
  MOBILE_APPS_OTHER = "mobile_apps_other",
  GOOGLE_ADS = "google_ads",
  FACEBOOK_ADS = "facebook_ads",
  BING_ADS = "bing_ads",
  PAID_ADS_OTHER = "paid_ads_other",
  TWITTER = "twitter",
  TWITTER_POST = "twitter_post",
  TIKTOK = "tiktok",
  TIKTOK_VIDEO = "tiktok_video",
  TIKTOK_PHOTO = "tiktok_photo",
  FACEBOOK = "facebook",
  FACEBOOK_POST = "facebook_post",
  FACEBOOK_VIDEO = "facebook_video",
  FACEBOOK_GROUPS = "facebook_groups",
  FACEBOOK_PAGE = "facebook_page",
  INSTAGRAM = "instagram",
  INSTAGRAM_POST = "instagram_post",
  YOUTUBE = "youtube",
  YOUTUBE_VIDEO = "youtube_video",
  TELEGRAM = "telegram",
  TELEGRAM_POST = "telegram_post",
  LINKEDIN = "linkedin",
  LINKEDIN_JOB = "linkedin_job",
  LINKEDIN_POST = "linkedin_post",
  REDDIT = "reddit",
  REDDIT_COMMENT = "reddit_comment",
  REDDIT_SUBREDDIT = "reddit_subreddit",
  GITHUB = "github",
  PINTEREST = "pinterest",
  DISCORD = "discord",
  WHATSAPP = "whatsapp",
  TRUTH_SOCIAL = "truth_social",
  FACEBOOK_PROFILE = "facebook_profile",
  SPOTIFY = "spotify",
  TWITCH = "twitch",
  THREADS = "threads",
  SNAPCHAT = "snapchat",
  WEIBO = "weibo",
  WEIBO_POST = "weibo_post",
  MEDIUM = "medium",
  LINKTREE = "linktree",
  TUMBLR = "tumblr",
  SOCIAL_MEDIA_OTHER = "social_media_other",
  TELCO = "telco",
  SUSPICIOUS_EMAILS = "suspicious_emails",
  CLOUDFLARE_PAGES = "cloudflare_pages",
  DEXSCREENER = "dexscreener",
  UPBIT = "upbit",
  KRAKEN = "kraken",
  KUCOIN = "kucoin",
  MEXC = "mexc",
  TRADINGVIEW = "tradingview",
  CRYPTORANK = "cryptorank",
  BYBIT = "bybit",
  HTX = "htx",
  LIVECOINWATCH = "livecoinwatch",
  BITSCREENER = "bitscreener",
  BLUESKY = "bluesky",
  SUIVISION = "suivision",
  SUISCAN = "suiscan",
  SUIEXPLORER = "suiexplorer",
  KAKAO = "kakao",
  QUORA = "quora",
  NOTION = "notion",
  LINE_PUBLISHER = "line_publisher",
  LINE_POST = "line_post",
}

export enum PlatformSubtypeId {
  COINBASE = "162f925c-fe0c-4374-a92e-6edbf41d408c",
  BINANCE = "8a8a53ca-7380-43e5-9ba2-c759083a9c09",
  OPENSEA = "3ed1a2b6-4992-4b10-b47d-54b5a00c9fe6",
  MINTABLE = "aa812de4-4e3d-4fb4-ab8d-d3e48f7ada53",
  MAGICEDEN = "8f90f2d6-a3d3-4c5c-9493-73a3c4abaad2",
  OKX = "b68fb590-7a51-44ee-bef9-a6ee316ee998",
  RARIBLE = "84ae12b3-b2e0-4e47-a51a-dd9349ecccff",
  CRYPTO_OTHER = "4f1cf31d-dd44-4cdb-92a6-59cd0fc0d29d",
  SHELLIX = "07cf95d2-3f7e-454e-9511-582cae22864e",
  DARKMARKET_OTHER = "fbebc352-71f6-46e2-91cc-7dbab6c415b4",
  DARKWEB = "f63713b6-4b98-41d5-8b2b-d50700cd214c",
  CRED_LEAKS = "f41fbadc-7871-489b-b31a-8b1a3930616e",
  CREDIT_CARD_LEAKS = "38b4dec9-e23b-4587-9c5d-f2ccb89c209c",
  API_LEAKS = "d876ab72-ab37-43aa-80d0-b087a6e67dc5",
  DOMAINS = "68a517dd-9345-4138-888a-ccef309847df",
  ROOT_DOMAIN = "6e58938b-a15d-4b73-875b-500552db0b3d",
  GITBOOK = "dd265ffd-8812-4fdd-aac0-17275f49d37d",
  WEBFLOW = "c292648e-3cec-4239-9c42-82f007e6a83e",
  SHOPEE = "6d0382af-7572-4cc9-8983-baff7715ad65",
  BEST_ALIEXPRESS = "5a5547b2-b9d1-40c1-86dc-0e3234015519",
  WISH = "c9a448f8-f603-4b8f-93fe-c1ebe4b9317a",
  WILDBERRIES = "563e4d0e-8164-4fa0-924c-1c890ef7d3c6",
  ALIBABA = "f98bb515-db49-40f4-be0b-739aa17978a7",
  ROBLOX = "14832a79-57cb-4489-8511-6302ab063b36",
  AMAZON = "daf0662a-4927-4bd5-9cac-ae4a95de2157",
  WALMART = "86cb41ad-d7ab-4fba-b3d1-55388099dcc0",
  CRAIGSLIST = "deb188cf-904a-4af0-bbe2-c3b6dab5bfdf",
  ETSY = "dec13253-0f21-429e-aec1-ef3549ab7cad",
  EBAY = "8962b067-4b16-4133-bbf6-28b11b6800ca",
  LAZADA = "3365fc81-a070-4a65-8636-7bda440a979c",
  Z2U = "206265a6-102e-447f-8264-4b0688f38095",
  TOKOPEDIA = "eb5465c0-094f-44e2-92ab-d04d1f17f023",
  FACEBOOK_MARKETPLACE = "0ddbfbe5-ca35-4823-9c06-00cd3dc2e382",
  ECOMMERCE_OTHER = "575a839f-fb3f-4966-9518-f7679af3bc24",
  EMAIL = "10aa66d0-f5a3-4d22-9874-d60edfb4c9dc",
  APPLE_APP_STORE = "4a21c36e-5487-46fc-8477-d68aa303e279",
  APKGK = "1c012f7f-0b3d-45d7-ac85-0f582bf20116",
  UPTODOWN = "324ac9e3-83de-46ed-9b65-692dc3b2625b",
  STEPRIMO = "066d6868-5c64-4a8d-ad7b-10a6535ac41d",
  APPBRAIN = "eb631b90-8fac-4660-b272-ed9799ec7d57",
  GOOGLE_PLAY_STORE = "dd826a38-9ee1-4a48-971e-aacbbfe26735",
  APTOIDE = "d128e43a-11c7-4304-b7c4-359a62bfd4ac",
  NINEAPPS = "822bafe4-cc2b-4599-94ab-dfd208ce3659",
  APKCOMBO = "d5349cd4-2fff-44e2-9321-07845ffac7e7",
  APKPURE = "220568ac-6c30-478f-a97b-b0d7ba95d331",
  CAFEBAZAAR = "a2511c3e-0c2b-4e67-8957-ab231727dd21",
  GAMELOOP = "ed46743d-1f80-4310-891c-6e19c362a65e",
  HAPPYMOD = "2f414aca-c399-4e26-a9ba-b19a8ff11aee",
  APKHOUSE = "76b02bde-c6df-4e9d-a447-36768e8f2557",
  IODROID = "583355d6-b501-42e9-abbe-680788049d80",
  MALAVIDA = "0785b546-3631-429d-8281-5ae34851f7f0",
  APKMODY = "e5d6987f-8fa4-4218-bce6-8f9ed0bd4d32",
  APK4K = "d153ba58-1d3f-4182-ad21-1a2dcd229135",
  APKFREE = "85d1b2c7-ec44-4182-8416-fe21cf5241d6",
  APKDOWNLOAD = "c2d88659-c6a4-4076-91df-39a302a6434b",
  APKMONK = "f44b1165-cf65-4722-a250-b08931e217d8",
  APKSOS = "863ba19a-2da6-42f4-9375-58f417fd21a7",
  APKSUPPORT = "2b250e79-44e2-4f3e-af4d-a68786973d85",
  APKTOY = "f8e26477-7670-4ccc-96db-25cfb99b8cc9",
  FILEHIPPO = "0c0f6a55-9f79-447e-98ee-609abd2bc304",
  _99IMAGES = "8e9b95da-7272-4445-bc5f-b8b012bb6916",
  APKDOG = "6bc5c401-b908-4535-88fa-abe11dabd09c",
  APKBOG = "7defc7a6-1ea4-4a85-a130-40b2861188ec",
  APKLUST = "ae625b1d-f853-445f-84d1-e642fd773e45",
  APPSONWINDOWS = "6ed97af3-a36c-4b81-a1a7-37a961591667",
  NEDGET = "f3540d58-6ba0-4d90-82a5-c3a6c84d1396",
  SOFTONIC = "adf9a166-88a2-4557-9c5a-f3a45b7c081f",
  SOFTSTON = "18930924-deac-4efc-945b-632729fb16b4",
  GETJAR = "aa51ecb0-25d7-4d99-a48e-f85245963be0",
  APKMIRROR = "a47db95e-10ab-46f4-ae4d-a913ac5e7ccb",
  OPERA = "17705438-d82c-41d7-b210-6387ce3792b0",
  FILEHORSE = "ca77cf90-4791-42d9-8d24-6637c169b8d0",
  UOLDOWN = "1bcaa534-2d4f-4a77-8ada-78c244651555",
  APKDOWNLOADHUNT = "a0eed174-cba4-4097-9940-61fc6f7db000",
  APKLOO = "be4342ee-f3fe-4432-9906-8329771abc26",
  APKNITE = "2d44d62a-2a0b-4701-adbc-e738989c0ab3",
  APPVN = "5ac0bdb9-4c8d-4044-a0fd-ec41e0000ffe",
  SMARTLOADS = "3bfcb80c-a41c-4359-9172-221cecab4ca6",
  LUCKYMODAPK = "253f5af6-94b1-428b-b767-5c818b0c02ff",
  APKSHUB = "33dab6eb-06e2-46c0-a4e1-1f2520e9099b",
  CAPTAINDROID = "27592ec7-b24f-4eb6-9879-495c9ec73916",
  IPA4FUN = "aabe515e-ce2b-4d7e-9936-138f7547bb2f",
  AAPKS = "d1ea82d5-4377-4e2e-af5a-48af0c9bd139",
  APKMODULE = "e8f81a6e-de3f-4d45-a101-5ae39383ff65",
  APK20 = "81c557ad-e128-444d-a14c-4d9e6b959dda",
  APKFOLLOW = "ae986fa6-cb7b-46d8-a0ca-d83c35ecf579",
  APKSOUL = "fc982426-eae3-40c5-aef3-3f0f649e48f5",
  ANDROIDFREEWARE = "56082450-c406-4f69-8424-2b2b9d3ea46f",
  PCMACSTORE = "3313a84d-d0eb-4dab-a6d9-b27e511a3b74",
  ANDROIDBLUE = "4e1a6baa-7c39-4246-bdac-72aca8c6764e",
  MODDROID = "c4b12f8e-d2a5-4b67-b536-09f1c87475d7",
  APKDOM = "3d6cce80-667b-4bc1-95a1-edd285a2870b",
  WEBCATALOG = "ae83eeea-782d-4e5f-9c99-1022094b5a4c",
  ANDROIDAPPSAPK = "e48aabce-bf26-4e9a-a1ce-d17506047a4c",
  SOFT112 = "ddf0e03b-156d-49ec-b515-b8dedc59149f",
  A2ZAPK = "78207ecb-f48b-4021-b19a-6f49788ab504",
  BIGNOX = "a111a6c0-bdbd-4bd6-b230-a696e276f566",
  NAPKFORPC = "885fc366-4001-455d-a13b-83d3329688bf",
  APKVISIT = "ff452693-180b-469e-acc1-1182ae22a944",
  APKBE = "5d3947dd-37a9-4326-992d-0e61167e047d",
  PHONEKY = "f2115147-726c-4366-b12d-f125f3f0e320",
  APK3 = "b8786e1c-cf52-40d1-8949-5c07059762f8",
  APPONIC = "08683cbc-7ba4-4c13-a665-b39fd0ef6af7",
  ANDRIODAPK = "ee10ddc9-2b32-4ad8-a997-f76988d11573",
  MODPURE = "3ced7038-4e87-4805-9601-4b269649ac7d",
  JOJOY = "2172e926-1de6-44ea-b9c8-d30bf488f5f9",
  APKSTREAMZ = "5297a001-5328-47c4-af6e-b15fc399ad5e",
  APK4FUN = "4b175204-66c9-4a8a-a1eb-7c78502514ff",
  APKBIND = "0f2e1588-3558-41a7-9693-373a5beda92a",
  APKVISION = "19de2597-aad1-4627-b359-c75e11f549cb",
  ANDROIDOUT = "67a3d2bc-5384-4694-a3c0-d17a93f8fe65",
  DFAST = "bd4cd6b2-adba-45cd-b1bc-9baba368c4f3",
  MODCOMBO = "4548d8d0-034c-426d-83a7-cf11860dcd6e",
  MEMUPLAY = "54fb1232-ecfa-4fd7-b57b-ddf8f3f468f9",
  VEAPPS = "637a20bb-2332-4f3e-8e63-e26b7946186d",
  APKCAFE = "91baee0d-a444-4cc0-9704-598505d1dddd",
  APKSHKI = "5a3e357f-b643-45e7-bc46-75055ec456d5",
  KINGMODAPK = "6e03b782-3aa6-4f8d-a7b2-cb2574279bf3",
  APKGOLD = "2f7ebff6-1ab1-4e68-b084-672f820d7b42",
  ANDROIDGOZAR = "d1fba416-2d1e-4cca-8a15-59235b251a2d",
  CRX4CHROME = "9b9f0807-8a23-41a2-9d4e-a151b9f84c1b",
  APKAMP = "e0f94a47-bd48-41b5-ba28-5f19d9e111bb",
  APKTUME = "abfc0411-862d-4e76-a91d-94cfded2f68a",
  APPLATEST = "bb6d6f4d-a378-4526-ab5c-4d988fcf8664",
  APKEASY = "2a33729a-e1e4-4c11-b7e2-c57006145675",
  APKNITRO = "bd3d1bd7-50cf-40b5-9f6c-38d9b49fb696",
  BAIXEFACIL = "e9615b64-4d7b-47ad-8038-946247b1e747",
  ANDROIDLISTA = "86f04371-e38b-4ca6-91db-67e5dfbb929e",
  MATJARAPK = "cef7bd4b-4e70-4e1c-9dfd-8198931cbe33",
  GOZLA = "2a99086c-a654-4eeb-b3cb-47882fafc6ee",
  APKWATCH = "72e878e3-0520-4937-8a35-106bc29f246b",
  APKSSOFTWARE = "e79c72e5-22cc-4af3-ab2d-28f8626d09c2",
  KERNAPK = "9dbeb8d8-c956-48fe-b3e4-d972d8eafc7f",
  APKTIP = "f7762042-2421-484e-b7e9-11c8ef5c2106",
  APKUNDUH = "6021b020-9a38-42a8-a6be-264f4546d670",
  TRAPK = "a4f358be-0149-4a1a-aa05-6d452474a88a",
  MODAPKDOWN = "d42337f9-d8d3-4bc2-a59d-a8e1d33003cc",
  MODAPKCLOUD = "d8ba0c07-1ac8-4975-8805-e4c1e76f2330",
  LDPLAYER = "68eb4824-9bb0-4e6b-b480-b5c4ea1459f8",
  ANDROIDBLIP = "a822ce37-2374-4045-9524-a6808e83afd4",
  FREEAPK = "65ba29dd-df62-43e2-842e-6213d0eabc8b",
  MOBILE_APPS_OTHER = "d8848696-8a02-4e32-8fc8-3e4c01c136c0",
  GOOGLE_ADS = "b049dff7-9075-4eb2-8d19-5c7bf18c4195",
  FACEBOOK_ADS = "e0c8b792-43c2-41f3-ba85-c8ecf7b63ea8",
  BING_ADS = "e53c115f-0afc-4bfe-927f-7c0b217c7afa",
  PAID_ADS_OTHER = "f81ff234-0f97-49a6-bf04-a785e023c190",
  TWITTER = "1422c0b9-ea0a-43bf-9f68-799015afe642",
  TWITTER_POST = "ce2ae0dd-942c-4cf3-8155-a9c684ca527b",
  TIKTOK = "d52b361e-94a9-4ee7-8cf9-c1aaf5cd4c9d",
  TIKTOK_VIDEO = "c703fd68-e25c-4163-8357-430c446db5e3",
  TIKTOK_PHOTO = "4c0d3dcc-d108-4f4d-be0b-ded043141bd5",
  FACEBOOK = "5d03c276-448e-4036-b1a3-35be25ee5e35",
  FACEBOOK_POST = "5b0082e1-bde2-4744-a604-436cb428121c",
  FACEBOOK_VIDEO = "58343c29-9ef8-4bf6-9f46-d6f56346a43e",
  FACEBOOK_GROUPS = "58e518d9-2ce3-4f9d-813c-baa1be1e842e",
  FACEBOOK_PAGE = "f930ffe7-6006-42e2-b0ba-af8d71dee338",
  INSTAGRAM = "19ac9b4e-fb9c-4350-b5f3-f55347809457",
  INSTAGRAM_POST = "d93a1fb3-2fae-425e-893c-a450238a52f4",
  YOUTUBE = "c751b205-50ee-4358-ae6b-4af48483bcec",
  YOUTUBE_VIDEO = "80e1b992-af2e-4f19-b911-ff6fd4c95134",
  TELEGRAM = "fcb65ff5-06d2-4e5b-9b9f-63dc2d64579a",
  TELEGRAM_POST = "28d64ef6-074f-42c0-9db4-3974961ee8e5",
  LINKEDIN = "7913ed24-b421-4e57-a986-52c722944daa",
  LINKEDIN_JOB = "d1977ec7-9b98-4747-8b10-495e1a63d2da",
  LINKEDIN_POST = "e6d076b5-4e1c-464d-bf2d-609e39984ca2",
  REDDIT = "a3e5997d-2eb9-407f-82e7-e8bfc07c343a",
  REDDIT_COMMENT = "2e469930-ad8b-461c-b662-2fa009dbc940",
  REDDIT_SUBREDDIT = "72bd6122-963e-4a25-8fc5-74d931f0df94",
  GITHUB = "8a559b31-7dfb-49f9-af77-4b720076efec",
  PINTEREST = "a37ddc33-874b-43e3-9150-e85072e6938c",
  DISCORD = "309d4fd7-0cf7-43f4-9edf-54f32fa49298",
  WHATSAPP = "f294fc77-8968-45c1-877d-7fdfdadc54f5",
  TRUTH_SOCIAL = "a7c57162-4437-4cc8-ad7c-314782238903",
  FACEBOOK_PROFILE = "752ba41a-a929-43d7-b765-1b623245bf7f",
  SPOTIFY = "bd1b4a58-acbb-4f33-9b77-557fd4de0488",
  TWITCH = "3d7e7c4e-d4f2-4f80-a7e6-a6c0a8ca12ac",
  THREADS = "1f013ba5-2e44-45d5-878c-c7ad34b80022",
  SNAPCHAT = "da3dd4cc-9eac-4ddc-a413-f5f9b212d3fe",
  WEIBO = "05a3e31b-1acb-430f-827f-6b81b8902a7d",
  WEIBO_POST = "eeca6f64-6c68-41b8-af5b-6cb22434d1c1",
  MEDIUM = "b8268c27-245f-493b-bfef-6eeb6a07d9cb",
  LINKTREE = "7fbb3170-ead8-4734-b06b-7b1a73f62b22",
  TUMBLR = "ae54ec20-3061-41f5-9a23-b41d5ba6de96",
  SOCIAL_MEDIA_OTHER = "1b626269-cb0a-40be-81a9-74c1cba35890",
  TELCO = "103ce2aa-4623-4a80-ac08-205079e80ded",
  SUSPICIOUS_EMAILS = "8294af10-c854-4c4f-a066-3282655745cd",
  CLOUDFLARE_PAGES = "aecbae92-e822-4063-993c-b6bff665cda9",
  DEXSCREENER = "2891954b-f975-4837-b239-92000ec8e9fb",
  UPBIT = "c8ccc1fe-b979-4bbe-952c-ed6ae0e0d538",
  KRAKEN = "f9642b7b-56bf-4130-a73d-73e04edd9a92",
  KUCOIN = "d0d89458-ef3c-4159-b5f5-a674a1ffc476",
  MEXC = "c2451ef9-0241-40c1-bf6d-7f8624bc4a9b",
  TRADINGVIEW = "362c391c-4f39-4e30-aae2-fd46ed84ad35",
  CRYPTORANK = "dd60d778-abbf-4b1d-9838-a2edce654bd3",
  BYBIT = "7a074dda-c5ac-4e02-962c-44f6335bca46",
  HTX = "fc4f8cef-7d04-4582-90dd-5324ee8e2b7d",
  LIVECOINWATCH = "4ff272d7-a6fa-48f7-8217-f98bd3c93c6c",
  BITSCREENER = "e759805f-160e-4875-b9ad-7c43a5fedcaa",
  BLUESKY = "d0a32dd7-0c7e-463d-b322-0bbcd22a8b17",
  SUIVISION = "5fabc8d3-8849-44e8-9fc2-cb03718b8d1e",
  SUISCAN = "0aeb26ad-99e8-46f8-8add-b497f7ea97d4",
  SUIEXPLORER = "aabd00cc-2a2d-48af-8704-2d46daeae671",
  KAKAO = "cd524175-97e2-40c2-b50c-c70bb6fef6d7",
  QUORA = "a7d821a4-f5ab-4a9b-a2d4-25768f80497c",
  NOTION = "6eac5302-13ab-49aa-907d-454883867afb",
  LINE_PUBLISHER = "5afc9828-e2ac-4927-8491-a90af1b304d3",
  LINE_POST = "e1ffff62-cd31-4962-b444-a9f9e2e3ce0b",
}

export enum ProductType {
  DOMAIN = "domains",
  URL = "urls",
  SOCIAL_MEDIA = "social_media",
  CRYPTO = "crypto",
  MOBILE_APP = "mobile_apps",
  PAID_AD = "paid_ads",
  ECOMMERCE = "ecommerce",
  EMAIL = "email",
  DARKWEB = "darkweb",
  DARK_MARKET = "darkmarket",
  TELCO = "telco",
  SUSPICIOUS_EMAILS = "suspicious_emails",
  PHISHING_SIM = "phishing_sim",
  METAVERSE = "metaverse",
  CODE_REPOS = "code_repos",
  PII = "pii",
  DOMAIN_PURCHASING = "domain_purchasing",
  THREATS = "threats",
  PHYSICAL_THREATS = "physical_threats",
  PII_REMOVAL = "pii_removal",
  CREDENTIAL_LEAKS = "credential_leaks",
  MENTIONS = "mentions",
  IGNORED = "ignored",
}

export enum Archetype {
  DOMAIN = "domains",
  ROOT_DOMAIN = "root_domain",
  SOCIAL_MEDIA = "social_media",
  SOCIAL_MEDIA_POST = "social_media_post",
  SOCIAL_MEDIA_GROUP = "social_media_group",
  CRYPTO = "crypto",
  MOBILE_APP = "mobile_apps",
  PAID_AD = "paid_ads",
  ADVERTISER = "advertiser",
  ECOMMERCE = "ecommerce",
  EMAIL = "email",
  DARKWEB = "darkweb",
  CRED_LEAKS = "cred_leaks",
  CREDIT_CARD_LEAKS = "credit_card_leaks",
  API_LEAKS = "api_leaks",
  DARK_MARKET = "darkmarket",
  TELCO = "telco",
  SUSPICIOUS_EMAILS = "suspicious_emails",
  CODE_REPOS = "code_repos",
}

export enum ProductTypePath {
  DOMAIN = "domains",
  SOCIAL_MEDIA = "socialmedia",
  CRYPTO = "crypto",
  MOBILE_APP = "mobileapps",
  PAID_AD = "paidads",
  ECOMMERCE = "ecommerce",
  EMAIL = "email",
  DARKWEB = "darkweb",
  DARK_MARKET = "darkmarket",
  TELCO = "telco",
  SUSPICIOUS_EMAILS = "employee-abusebox",
  PHISHING_SIM = "phishing-sim",
  METAVERSE = "gaming",
  CODE_REPOS = "code-repos",
  PII = "pii",
  DOMAIN_PURCHASING = "domain-purchasing",
  THREATS = "executive-protection/threats",
  PHYSICAL_THREATS = "executive-protection/physical-threats",
  PII_REMOVAL = "executive-protection/pii-removal",
  CREDENTIAL_LEAKS = "executive-protection/credential-leaks",
  MENTIONS = "executive-protection/mentions",
}

